(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3934],{

/***/ 28624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Support; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CartSupport/Support.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Wrapper",
  componentId: "sc-7gaa89-0"
})(["border:1px solid ", ";border-radius:", ";padding:", ";margin-top:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25), function (props) {
  return props.withoutMargin ? 0 : (0,polished_esm/* rem */.hO)(60);
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Content",
  componentId: "sc-7gaa89-1"
})(["display:flex;"]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Supportelements__Image",
  componentId: "sc-7gaa89-2"
})(["min-width:", ";height:", ";border-radius:50%;min-height:", ";height:", ";@media (min-width:", "px){min-height:", ";min-width:", ";}"], (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(105), (0,polished_esm/* rem */.hO)(105));
var Details = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Details",
  componentId: "sc-7gaa89-3"
})(["display:flex;flex-direction:column;padding-left:", ";position:relative;width:100%;@media (min-width:", "px){justify-content:center;}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var Question = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Supportelements__Question",
  componentId: "sc-7gaa89-4"
})(["font-size:", ";padding-bottom:", ";display:block;line-height:", ";font-weight:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Supportelements__Label",
  componentId: "sc-7gaa89-5"
})(["padding-bottom:", ";line-height:", ";a{color:", ";font-weight:", ";}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(26), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
});
var Phone = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Phone",
  componentId: "sc-7gaa89-6"
})(["a{font-weight:", ";color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CartSupport/Support.tsx







var SupportTemplate = function SupportTemplate(_ref) {
  var withoutMargin = _ref.withoutMargin,
      withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    withoutMargin: withoutMargin,
    withoutBackground: withoutBackground,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Question, {
      children: t('cart.support.question')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)('/team_person5_square.webp')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Details, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: t('cart.support.description')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Phone, {
          dangerouslySetInnerHTML: {
            __html: t('cart.support.phone')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var Support = (SupportTemplate);

/***/ }),

/***/ 28672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Conference_Conference; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
;// CONCATENATED MODULE: ./src/interfaces/Conference.ts
var Conference_CONFERENCE_TYPE;

(function (CONFERENCE_TYPE) {
  CONFERENCE_TYPE[CONFERENCE_TYPE["EPI"] = 1] = "EPI";
  CONFERENCE_TYPE[CONFERENCE_TYPE["PP"] = 0] = "PP";
  CONFERENCE_TYPE[CONFERENCE_TYPE["DNA"] = 2] = "DNA";
  CONFERENCE_TYPE[CONFERENCE_TYPE["CSKONGRES"] = 3] = "CSKONGRES";
})(Conference_CONFERENCE_TYPE || (Conference_CONFERENCE_TYPE = {}));

var COMPONENT_TYPE;

(function (COMPONENT_TYPE) {
  COMPONENT_TYPE[COMPONENT_TYPE["HERO"] = 0] = "HERO";
  COMPONENT_TYPE[COMPONENT_TYPE["PERSONS"] = 1] = "PERSONS";
  COMPONENT_TYPE[COMPONENT_TYPE["PROGRAM"] = 2] = "PROGRAM";
  COMPONENT_TYPE[COMPONENT_TYPE["INVITATIONS"] = 3] = "INVITATIONS";
  COMPONENT_TYPE[COMPONENT_TYPE["TICKETS"] = 4] = "TICKETS";
  COMPONENT_TYPE[COMPONENT_TYPE["ACCOMODATION"] = 5] = "ACCOMODATION";
  COMPONENT_TYPE[COMPONENT_TYPE["PARTNERS"] = 6] = "PARTNERS";
  COMPONENT_TYPE[COMPONENT_TYPE["ARCHIVE"] = 7] = "ARCHIVE";
  COMPONENT_TYPE[COMPONENT_TYPE["REFERENCES"] = 8] = "REFERENCES";
  COMPONENT_TYPE[COMPONENT_TYPE["ATTACHMENTS"] = 9] = "ATTACHMENTS";
  COMPONENT_TYPE[COMPONENT_TYPE["VIDEO"] = 10] = "VIDEO";
  COMPONENT_TYPE[COMPONENT_TYPE["ABOUT"] = 11] = "ABOUT";
  COMPONENT_TYPE[COMPONENT_TYPE["NOTICERECORDING"] = 12] = "NOTICERECORDING";
  COMPONENT_TYPE[COMPONENT_TYPE["CONTACT"] = 13] = "CONTACT";
  COMPONENT_TYPE[COMPONENT_TYPE["ORDERFORMTICKET"] = 14] = "ORDERFORMTICKET";
  COMPONENT_TYPE[COMPONENT_TYPE["OPENEVENT"] = 15] = "OPENEVENT";
  COMPONENT_TYPE[COMPONENT_TYPE["PHOTOGALLERY"] = 16] = "PHOTOGALLERY";
  COMPONENT_TYPE[COMPONENT_TYPE["REPORTAGEVIDEO"] = 17] = "REPORTAGEVIDEO";
  COMPONENT_TYPE[COMPONENT_TYPE["STREAM"] = 18] = "STREAM";
})(COMPONENT_TYPE || (COMPONENT_TYPE = {}));
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/ConferenceAccomodation/ConferenceAccomodation.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__Wrapper",
  componentId: "sc-xhzqxo-0"
})(["padding:", " 0 ", " 0;border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceAccomodationelements__Title",
  componentId: "sc-xhzqxo-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceAccomodationelements__TitleSymbol",
  componentId: "sc-xhzqxo-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__Description",
  componentId: "sc-xhzqxo-3"
})(["margin:0;padding:", " ", ";line-height:", ";", ";"], (0,polished_esm/* rem */.hO)(20), function (prop) {
  return prop.withoutSidePadding ? (0,polished_esm/* rem */.hO)(0) : (0,polished_esm/* rem */.hO)(20);
}, (0,polished_esm/* rem */.hO)(20), function (prop) {
  var _prop$colors;

  return !prop.withBackground ? '' : "background: ".concat((_prop$colors = prop.colors) === null || _prop$colors === void 0 ? void 0 : _prop$colors.colorLightest);
});
var DescAccomodations = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__DescAccomodations",
  componentId: "sc-xhzqxo-4"
})(["display:flex;flex-direction:column;flex-wrap:wrap;justify-content:start;@media (min-width:", "px){flex-direction:row;}"], theme/* breakpoints.xs */.A.xs);
var DescAccomodation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__DescAccomodation",
  componentId: "sc-xhzqxo-5"
})(["display:flex;flex-direction:column;width:50%;", ";padding:", " ", ";align-items:start;@media (max-width:", "px){width:100%;}"], function (prop) {
  return prop.oneNight ? 'width: 100%' : 'width: 50%';
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.xs */.A.xs);
var Rooms = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__Rooms",
  componentId: "sc-xhzqxo-6"
})(["margin-bottom:", ";width:80%;padding-left:10%;@media (max-width:", "px){width:100%;padding-left:0;}"], (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm);
var Room = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__Room",
  componentId: "sc-xhzqxo-7"
})(["display:flex;padding-bottom:", ";align-items:center;"], (0,polished_esm/* rem */.hO)(5));
var RoomRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__RoomRow",
  componentId: "sc-xhzqxo-8"
})(["display:flex;margin-bottom:", ";align-items:center;", ";"], (0,polished_esm/* rem */.hO)(5), function (prop) {
  var _prop$colors2;

  return "background: ".concat((_prop$colors2 = prop.colors) === null || _prop$colors2 === void 0 ? void 0 : _prop$colors2.colorLight);
});
var Col1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__Col1",
  componentId: "sc-xhzqxo-9"
})(["float:left;width:33.3%;", ";", ";", ";align-items:left;"], function (prop) {
  var _prop$colors3, _prop$colors4;

  return prop.isHead ? "background: ".concat((_prop$colors3 = prop.colors) === null || _prop$colors3 === void 0 ? void 0 : _prop$colors3.colorLink) : "background: ".concat((_prop$colors4 = prop.colors) === null || _prop$colors4 === void 0 ? void 0 : _prop$colors4.colorLight);
}, function (prop) {
  return prop.isHead ? "color: #fff " : "color: #000";
}, function (prop) {
  return prop.isHead ? "padding: ".concat((0,polished_esm/* rem */.hO)(10), " ").concat((0,polished_esm/* rem */.hO)(10)) : "padding: ".concat((0,polished_esm/* rem */.hO)(6), " ").concat((0,polished_esm/* rem */.hO)(10));
});
var Col2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__Col2",
  componentId: "sc-xhzqxo-10"
})(["float:left;width:33.3%;", ";", ";", ";align-items:left;"], function (prop) {
  var _prop$colors5, _prop$colors6;

  return prop.isHead ? "background: ".concat((_prop$colors5 = prop.colors) === null || _prop$colors5 === void 0 ? void 0 : _prop$colors5.colorLink) : "background: ".concat((_prop$colors6 = prop.colors) === null || _prop$colors6 === void 0 ? void 0 : _prop$colors6.colorLight);
}, function (prop) {
  return prop.isHead ? "color: #fff " : "color: #000";
}, function (prop) {
  return prop.isHead ? "padding: ".concat((0,polished_esm/* rem */.hO)(10), " ").concat((0,polished_esm/* rem */.hO)(10)) : "padding: ".concat((0,polished_esm/* rem */.hO)(6), " ").concat((0,polished_esm/* rem */.hO)(10));
});
var Col3 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAccomodationelements__Col3",
  componentId: "sc-xhzqxo-11"
})(["float:left;width:33.3%;", ";", ";", ";align-items:left;"], function (prop) {
  var _prop$colors7, _prop$colors8;

  return prop.isHead ? "background: ".concat((_prop$colors7 = prop.colors) === null || _prop$colors7 === void 0 ? void 0 : _prop$colors7.colorLink) : "background: ".concat((_prop$colors8 = prop.colors) === null || _prop$colors8 === void 0 ? void 0 : _prop$colors8.colorLight);
}, function (prop) {
  return prop.isHead ? "color: #fff " : "color: #000";
}, function (prop) {
  return prop.isHead ? "padding: ".concat((0,polished_esm/* rem */.hO)(10), " ").concat((0,polished_esm/* rem */.hO)(10)) : "padding: ".concat((0,polished_esm/* rem */.hO)(6), " ").concat((0,polished_esm/* rem */.hO)(10));
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ConferenceAccomodation/ConferenceAccomodation.tsx








var ConferenceAccomodationTemplate = function ConferenceAccomodationTemplate(_ref) {
  var _conf$conference, _conf$conference$acco, _conf$conference2, _conf$conference2$acc, _conf$conference3, _conf$conference3$acc, _conf$conference4, _conf$conference4$acc, _conf$conference5, _conf$conference5$acc, _conf$conference7, _conf$conference7$acc;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.ACCOMODATION),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
      colors: colors,
      children: [t('conference.component.accomodation.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(TitleSymbol, {
        colors: colors
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      colors: colors,
      dangerouslySetInnerHTML: {
        __html: conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : (_conf$conference$acco = _conf$conference.accomodation) === null || _conf$conference$acco === void 0 ? void 0 : _conf$conference$acco.blockFirst
      },
      withoutSidePadding: true
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : (_conf$conference2$acc = _conf$conference2.accomodation) === null || _conf$conference2$acc === void 0 ? void 0 : _conf$conference2$acc.rooms.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Rooms, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Room, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col1, {
            isHead: true,
            colors: colors,
            children: "N\xE1zev"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col2, {
            isHead: true,
            colors: colors,
            children: "Typ pokoje"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col3, {
            isHead: true,
            colors: colors,
            children: "Cena"
          })]
        }), conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : (_conf$conference3$acc = _conf$conference3.accomodation) === null || _conf$conference3$acc === void 0 ? void 0 : _conf$conference3$acc.rooms.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(RoomRow, {
            colors: colors,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col1, {
              colors: colors,
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col2, {
              colors: colors,
              children: item.type
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col3, {
              colors: colors,
              children: item.price
            })]
          }, "accRoom".concat(index));
        })]
      })
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference4 = conf.conference) === null || _conf$conference4 === void 0 ? void 0 : (_conf$conference4$acc = _conf$conference4.accomodation) === null || _conf$conference4$acc === void 0 ? void 0 : _conf$conference4$acc.descriptions.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DescAccomodations, {
        children: conf === null || conf === void 0 ? void 0 : (_conf$conference5 = conf.conference) === null || _conf$conference5 === void 0 ? void 0 : (_conf$conference5$acc = _conf$conference5.accomodation) === null || _conf$conference5$acc === void 0 ? void 0 : _conf$conference5$acc.descriptions.map(function (item, index) {
          var _conf$conference6, _conf$conference6$acc;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(DescAccomodation, {
            oneNight: (conf === null || conf === void 0 ? void 0 : (_conf$conference6 = conf.conference) === null || _conf$conference6 === void 0 ? void 0 : (_conf$conference6$acc = _conf$conference6.accomodation) === null || _conf$conference6$acc === void 0 ? void 0 : _conf$conference6$acc.descriptions.length) === 1,
            dangerouslySetInnerHTML: {
              __html: item.name
            }
          }, "accDesc".concat(index));
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      withBackground: true,
      colors: colors,
      dangerouslySetInnerHTML: {
        __html: conf === null || conf === void 0 ? void 0 : (_conf$conference7 = conf.conference) === null || _conf$conference7 === void 0 ? void 0 : (_conf$conference7$acc = _conf$conference7.accomodation) === null || _conf$conference7$acc === void 0 ? void 0 : _conf$conference7$acc.blockSecond
      }
    })]
  });
};

/* harmony default export */ var ConferenceAccomodation = (ConferenceAccomodationTemplate);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/utils/material.utils.ts
var material_utils = __webpack_require__(27098);
;// CONCATENATED MODULE: ./src/components/ConferenceAttachments/ConferenceAttachments.elements.tsx



var ConferenceAttachments_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAttachmentselements__Wrapper",
  componentId: "sc-t8eiav-0"
})(["padding:", " ", " ", " ", ";border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
var ConferenceAttachments_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceAttachmentselements__Title",
  componentId: "sc-t8eiav-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceAttachments_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceAttachmentselements__TitleSymbol",
  componentId: "sc-t8eiav-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var Tabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAttachmentselements__Tabs",
  componentId: "sc-t8eiav-3"
})(["display:flex;border-bottom:1px solid ", ";margin-top:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAttachmentselements__Tab",
  componentId: "sc-t8eiav-4"
})(["margin-right:", ";color:", ";cursor:pointer;&.active{font-weight:", ";border-bottom:2px solid ", ";padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(30), function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors4;

  return (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorLink;
}, (0,polished_esm/* rem */.hO)(10));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAttachmentselements__Content",
  componentId: "sc-t8eiav-5"
})(["margin:0 ", ";"], (0,polished_esm/* rem */.hO)(10));
var Attachment = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceAttachmentselements__Attachment",
  componentId: "sc-t8eiav-6"
})(["cursor:pointer;display:flex;padding-bottom:", ";align-items:center;"], (0,polished_esm/* rem */.hO)(5));
var AttachmentName = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferenceAttachmentselements__AttachmentName",
  componentId: "sc-t8eiav-7"
})(["cursor:pointer;display:flex;padding-bottom:", ";align-items:center;color:", ";"], (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors5;

  return (_props$colors5 = props.colors) === null || _props$colors5 === void 0 ? void 0 : _props$colors5.colorLink;
});
var AttachmentIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "ConferenceAttachmentselements__AttachmentIcon",
  componentId: "sc-t8eiav-8"
})(["padding:0 ", " 0 ", ";svg{width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30));
var ButtonDownload = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ConferenceAttachmentselements__ButtonDownload",
  componentId: "sc-t8eiav-9"
})(["border:none;color:", ";background:", ";border-radius:", ";font-weight:", ";padding:0 ", ";height:", ";margin-left:", ";margin-bottom:", ";margin-top:", ";cursor:pointer;box-shadow:0 0 4px ", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.white;
}, function (props) {
  var _props$colors6;

  return (_props$colors6 = props.colors) === null || _props$colors6 === void 0 ? void 0 : _props$colors6.colorLink;
}, (0,polished_esm/* rem */.hO)(4), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(75), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (props) {
  var _props$colors7;

  return (_props$colors7 = props.colors) === null || _props$colors7 === void 0 ? void 0 : _props$colors7.colorLink;
});
var InfoMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceAttachmentselements__InfoMessage",
  componentId: "sc-t8eiav-10"
})(["color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
});
;// CONCATENATED MODULE: ./src/components/ConferenceAttachments/ConferenceAttachments.tsx
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











var ConferenceAttachmentsTemplate = function ConferenceAttachmentsTemplate(_ref) {
  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)([]),
      attachments = _useState[0],
      setAttachments = _useState[1];

  var _useState2 = (0,react.useState)(false),
      termAccessible = _useState2[0],
      setTermAccessible = _useState2[1];

  (0,react.useEffect)(function () {
    if (conf) {
      for (var x = 0; x < (conf === null || conf === void 0 ? void 0 : conf.dates.length); x++) {
        for (var z = 0; z < (conf === null || conf === void 0 ? void 0 : conf.dates[x].attachments.length); z++) {
          var _conf$dates$x;

          attachments.push(conf === null || conf === void 0 ? void 0 : (_conf$dates$x = conf.dates[x]) === null || _conf$dates$x === void 0 ? void 0 : _conf$dates$x.attachments[z]);
        }
      }

      var attachmentsUnique = attachments.filter(function (value, index, self) {
        return self.map(function (x) {
          return x._key;
        }).indexOf(value._key) == index;
      });
      setAttachments(attachmentsUnique);

      var _iterator = _createForOfIteratorHelper(conf === null || conf === void 0 ? void 0 : conf.dates),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var date = _step.value;

          if (date.accessible) {
            setTermAccessible(true);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, [conf]);
  var orderedAttachments = attachments.sort(function (a, b) {
    return a.order - b.order;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceAttachments_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.ATTACHMENTS),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceAttachments_elements_Title, {
      colors: colors,
      children: [t('conference.component.attachments.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceAttachments_elements_TitleSymbol, {
        colors: colors
      })]
    }), attachments.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [orderedAttachments === null || orderedAttachments === void 0 ? void 0 : orderedAttachments.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Attachment, {
            onClick: function onClick() {
              return (0,material_utils/* handleDownloadClick */.b)(item._key, item.filename, false, item.mime_type);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AttachmentIcon, {
              name: Icon/* Icons.File */.PJ.File
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AttachmentName, {
              colors: colors,
              children: item.name
            })]
          }, "attachmentKey".concat(index))
        }, index);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonDownload, {
        colors: colors,
        onClick: function onClick() {
          var _conf$conference;

          return (0,material_utils/* handleDownloadClickAsZip */.h)(attachments, conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.slug);
        },
        children: t('conference.attachments.download.all')
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      children: [termAccessible && attachments.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessage, {
        children: t('conference.attachments.emptyResult.accessible')
      }), !termAccessible && attachments.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessage, {
        children: t('conference.attachments.emptyResult')
      })]
    })]
  });
};

/* harmony default export */ var ConferenceAttachments = (ConferenceAttachmentsTemplate);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
;// CONCATENATED MODULE: ./src/components/ConferenceContact/ConferenceContact.elements.tsx




var ConferenceContact_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceContactelements__Wrapper",
  componentId: "sc-8ra5k5-0"
})(["padding:", " 0 ", " 0;border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
var ConferenceContact_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__Title",
  componentId: "sc-8ra5k5-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceContact_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__TitleSymbol",
  componentId: "sc-8ra5k5-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var Sections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceContactelements__Sections",
  componentId: "sc-8ra5k5-3"
})(["display:flex;flex-direction:column;font-weight:", ";gap:", ";@media (min-width:", "px){flex-direction:row;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm);
var Contacts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceContactelements__Contacts",
  componentId: "sc-8ra5k5-4"
})(["@media (min-width:", "px){width:50%;}"], theme/* breakpoints.sm */.A.sm);
var Map = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceContactelements__Map",
  componentId: "sc-8ra5k5-5"
})(["height:", ";background:", ";padding:", ";position:relative;@media (min-width:", "px){width:50%;}> div{height:65% !important;}"], (0,polished_esm/* rem */.hO)(500), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var ContactSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceContactelements__ContactSection",
  componentId: "sc-8ra5k5-6"
})(["margin-top:", ";"], (0,polished_esm/* rem */.hO)(20));
var ContactSectionTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__ContactSectionTitle",
  componentId: "sc-8ra5k5-7"
})(["display:block;padding-top:", ";padding-bottom:", ";font-size:", ";font-weight:", ";"], function (props) {
  return props.withoutPaddingTop ? 0 : (0,polished_esm/* rem */.hO)(30);
}, (0,polished_esm/* rem */.hO)(5), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textBold;
});
var ContactSectionTitlePlace = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__ContactSectionTitlePlace",
  componentId: "sc-8ra5k5-8"
})(["display:block;padding-top:", ";padding-bottom:", ";font-size:", ";font-weight:", ";"], (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(5), function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.h6;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
});
var ContactSectionRow = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__ContactSectionRow",
  componentId: "sc-8ra5k5-9"
})(["display:flex;align-items:center;flex-direction:column;padding-top:", ";@media (min-width:", "px){flex-direction:row;}"], function (props) {
  return props.paddingTop ? (0,polished_esm/* rem */.hO)(props.paddingTop) : 0;
}, theme/* breakpoints.xs */.A.xs);
var ContactSectionPerson = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__ContactSectionPerson",
  componentId: "sc-8ra5k5-10"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(10));
var ContactSectionAddress = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__ContactSectionAddress",
  componentId: "sc-8ra5k5-11"
})(["padding-bottom:", ";display:block;"], (0,polished_esm/* rem */.hO)(5));
var ContactSectionIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "ConferenceContactelements__ContactSectionIcon",
  componentId: "sc-8ra5k5-12"
})(["margin-top:", ";svg{width:", ";height:", ";path{fill:", ";}}"], (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLine;
});
var ContactSectionLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferenceContactelements__ContactSectionLink",
  componentId: "sc-8ra5k5-13"
})(["color:", ";cursor:pointer;padding-left:", ";text-decoration:none;"], function (props) {
  var _props$colors4;

  return (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorLink;
}, (0,polished_esm/* rem */.hO)(10));
var Coordinates = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceContactelements__Coordinates",
  componentId: "sc-8ra5k5-14"
})(["font-size:", ";display:block;margin:", " 0 ", " 0;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(10));
var PointIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceContactelements__PointIcon",
  componentId: "sc-8ra5k5-15"
})(["background:none;border:none;cursor:pointer;position:absolute;right:", ";top:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(-30));
var ConferenceContact_elements_Icon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "ConferenceContactelements__Icon",
  componentId: "sc-8ra5k5-16"
})(["margin-right:", ";cursor:pointer;svg{width:", ";margin-top:", ";path,rect,circle{fill:", ";stroke:", ";}}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(4), function (props) {
  var _props$colors5;

  return (_props$colors5 = props.colors) === null || _props$colors5 === void 0 ? void 0 : _props$colors5.colorLine;
}, function (props) {
  var _props$colors6;

  return (_props$colors6 = props.colors) === null || _props$colors6 === void 0 ? void 0 : _props$colors6.colorLine;
});
var ContactMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceContactelements__ContactMap",
  componentId: "sc-8ra5k5-17"
})([""]);
;// CONCATENATED MODULE: ./src/components/ConferenceContact/ConferenceContact.tsx









var ConferenceContactTemplate = function ConferenceContactTemplate(_ref) {
  var _conf$conference, _conf$conference2, _venues$, _venues$2, _venues$3, _venues$4, _venues$5, _venues$6, _venues$6$iframe, _venues$6$iframe$spli, _venues$7, _venues$7$iframe, _venues$7$iframe$spli, _venues$8;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(null),
      eventDate = _useState[0],
      setEventDate = _useState[1];

  var _useState2 = (0,react.useState)([]),
      venues = _useState2[0],
      setVenues = _useState2[1];

  (0,react.useEffect)(function () {
    if (conf !== null && conf !== void 0 && conf.dates) {
      setEventDate(conf === null || conf === void 0 ? void 0 : conf.dates);
    }
  }, []);
  (0,react.useEffect)(function () {
    if (eventDate) {
      for (var x = 0; x < eventDate.length; x++) {
        for (var z = 0; z < eventDate[x].venues.length; z++) {
          var _eventDate$x;

          venues.push((_eventDate$x = eventDate[x]) === null || _eventDate$x === void 0 ? void 0 : _eventDate$x.venues[z]);
        }
      }

      var venuesUnique = venues.filter(function (value, index, self) {
        return self.map(function (x) {
          return x._key;
        }).indexOf(value._key) == index;
      });
      setVenues(venuesUnique);
    }
  }, [eventDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceContact_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.CONTACT),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceContact_elements_Title, {
      colors: colors,
      children: [t('conference.component.contact.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceContact_elements_TitleSymbol, {
        colors: colors
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
      children: [(conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.type) === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Contacts, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionPerson, {
              children: t('conference.contact.info')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.Phone */.PJ.Phone,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "tel:+420 212 247 824",
              children: "+420 212 247 824"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.MailOpen */.PJ.MailOpen,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "mailto:studiow@pp.cz",
              children: "studiow@pp.cz"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionRow, {
            paddingTop: 30,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionPerson, {
              children: "Partnerstv\xED a z\xE1jem o vystoupen\xED:"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionTitle, {
              withoutPaddingTop: true,
              children: "\u0160\xE1rka Jure\u010Dkov\xE1"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.Phone */.PJ.Phone,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "tel:+420 602 398 155",
              children: "+420 602 398 155"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.MailOpen */.PJ.MailOpen,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "mailto:jureckova@pp.cz",
              children: "jureckova@pp.cz"
            })]
          })]
        })
      }), (conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.type) === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Contacts, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionPerson, {
              children: t('conference.contact.info')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.Phone */.PJ.Phone,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "tel:+420 212 247 811",
              children: "+420 212 247 811"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.MailOpen */.PJ.MailOpen,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "mailto:blahutova@pp.cz",
              children: "blahutova@pp.cz"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.MailOpen */.PJ.MailOpen,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "mailto:kosutova@pp.cz",
              children: "kosutova@pp.cz"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionRow, {
            paddingTop: 30,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionPerson, {
              children: "Partnerstv\xED a z\xE1jem o vystoupen\xED:"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionTitle, {
              withoutPaddingTop: true,
              children: "Miroslav R\u016F\u017Ei\u010Dka"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.Phone */.PJ.Phone,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "tel:+420 737 518 210",
              children: "+420 737 518 210"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionIcon, {
              name: Icon/* Icons.MailOpen */.PJ.MailOpen,
              colors: colors
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionLink, {
              colors: colors,
              href: "mailto:ruzicka@pp.cz",
              children: "ruzicka@pp.cz"
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Map, {
        children: venues.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PointIcon, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceContact_elements_Icon, {
              name: Icon/* Icons.Point */.PJ.Point,
              colors: colors
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionTitlePlace, {
            children: t('conference.contact.venue')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionAddress, {
            children: (_venues$ = venues[0]) === null || _venues$ === void 0 ? void 0 : _venues$.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactSectionAddress, {
            children: (_venues$2 = venues[0]) === null || _venues$2 === void 0 ? void 0 : _venues$2.street
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactSectionAddress, {
            children: [(_venues$3 = venues[0]) === null || _venues$3 === void 0 ? void 0 : _venues$3.zip_code, ", ", (_venues$4 = venues[0]) === null || _venues$4 === void 0 ? void 0 : _venues$4.city]
          }), ((_venues$5 = venues[0]) === null || _venues$5 === void 0 ? void 0 : _venues$5.iframe) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Coordinates, {
            children: [t('conference.contact.gps'), ' ', "".concat((_venues$6 = venues[0]) === null || _venues$6 === void 0 ? void 0 : (_venues$6$iframe = _venues$6.iframe) === null || _venues$6$iframe === void 0 ? void 0 : (_venues$6$iframe$spli = _venues$6$iframe.split('!')[5]) === null || _venues$6$iframe$spli === void 0 ? void 0 : _venues$6$iframe$spli.substr(2), ", ").concat((_venues$7 = venues[0]) === null || _venues$7 === void 0 ? void 0 : (_venues$7$iframe = _venues$7.iframe) === null || _venues$7$iframe === void 0 ? void 0 : (_venues$7$iframe$spli = _venues$7$iframe.split('!')[6]) === null || _venues$7$iframe$spli === void 0 ? void 0 : _venues$7$iframe$spli.substr(2))]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactMap, {
            dangerouslySetInnerHTML: {
              __html: (_venues$8 = venues[0]) === null || _venues$8 === void 0 ? void 0 : _venues$8.iframe
            }
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var ConferenceContact = (ConferenceContactTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceDescription/ConferenceDescription.elements.tsx


var ConferenceDescription_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceDescriptionelements__Wrapper",
  componentId: "sc-l7xopw-0"
})(["padding:", " 0 ", " 0;border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
var ConferenceDescription_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceDescriptionelements__Title",
  componentId: "sc-l7xopw-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceDescription_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceDescriptionelements__TitleSymbol",
  componentId: "sc-l7xopw-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferenceDescription_elements_Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceDescriptionelements__Description",
  componentId: "sc-l7xopw-3"
})(["margin:0;line-height:", ";"], (0,polished_esm/* rem */.hO)(20));
;// CONCATENATED MODULE: ./src/components/ConferenceDescription/ConferenceDescription.tsx







var ConferenceDescriptionTemplate = function ConferenceDescriptionTemplate(_ref) {
  var _conf$conference;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceDescription_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.ABOUT),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceDescription_elements_Title, {
      colors: colors,
      children: [t('conference.component.description.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceDescription_elements_TitleSymbol, {
        colors: colors
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceDescription_elements_Description, {
      dangerouslySetInnerHTML: {
        __html: conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.anotation
      }
    })]
  });
};

/* harmony default export */ var ConferenceDescription = (ConferenceDescriptionTemplate);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/components/ConferenceLecturer/ConferenceLecturer.elements.tsx




var ConferenceLecturer_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerelements__Wrapper",
  componentId: "sc-5wlvgm-0"
})(["padding:", " 0;position:fixed;left:0;top:0;background-color:rgba(0,0,0,0.75);width:100vw;height:100vh;z-index:999999;display:flex;align-items:center;justify-content:center;"], (0,polished_esm/* rem */.hO)(40));
var Modal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerelements__Modal",
  componentId: "sc-5wlvgm-1"
})(["width:90%;height:90%;;background:white;border-radius:", ";position:relative;@media (min-width:", "px){width:", ";height:auto;}"], (0,polished_esm/* rem */.hO)(12), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(700));
var ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerelements__ModalContent",
  componentId: "sc-5wlvgm-2"
})(["width:100%;height:100%;@media (max-width:", "px){top:0;left:0;position:absolute;overflow:scroll;scrollbar-width:none;}"], theme/* breakpoints.sm */.A.sm);
var CloseButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerelements__CloseButton",
  componentId: "sc-5wlvgm-3"
})(["background:none;border:none;cursor:pointer;position:absolute;right:", ";top:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15));
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerelements__Header",
  componentId: "sc-5wlvgm-4"
})(["display:flex;flex-direction:column;min-height:", ";"], (0,polished_esm/* rem */.hO)(110));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferenceLecturerelements__Image",
  componentId: "sc-5wlvgm-5"
})(["width:", ";height:", ";border-radius:50%;border:", " solid white;@media (min-width:", "px){position:absolute;left:", ";top:-", ";}"], (0,polished_esm/* rem */.hO)(140), (0,polished_esm/* rem */.hO)(140), (0,polished_esm/* rem */.hO)(8), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15));
var Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceLecturerelements__Name",
  componentId: "sc-5wlvgm-6"
})(["font-weight:", ";font-size:", ";color:", ";display:block;padding:", " ", " 0 ", ";@media (min-width:", "px){margin-left:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h5;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorLink;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(175));
var Label = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceLecturerelements__Label",
  componentId: "sc-5wlvgm-7"
})(["padding:", " ", ";line-height:", ";margin:0;min-height:", ";@media (min-width:", "px){margin-left:", ";}"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(35), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(175));
var LabelPosition = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceLecturerelements__LabelPosition",
  componentId: "sc-5wlvgm-8"
})(["padding:", " ", " ", " ", ";line-height:", ";margin:0;min-height:", ";@media (min-width:", "px){margin-left:", ";}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(35), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(175));
var ConferenceLecturer_elements_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceLecturerelements__Description",
  componentId: "sc-5wlvgm-9"
})(["padding:", " ", " 0 ", ";line-height:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textBase;
});
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerelements__Footer",
  componentId: "sc-5wlvgm-10"
})(["display:flex;flex-direction:column;justify-content:space-between;padding:", " ", " ", " ", ";@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
var Social = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerelements__Social",
  componentId: "sc-5wlvgm-11"
})(["float:left;"]);
var ConferenceLecturer_elements_Icon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "ConferenceLecturerelements__Icon",
  componentId: "sc-5wlvgm-12"
})(["margin-right:", ";cursor:pointer;svg{width:", ";margin-top:", ";path,rect,circle{fill:", ";}}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(4), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
});
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferenceLecturerelements__Link",
  componentId: "sc-5wlvgm-13"
})(["float:left;display:flex;align-items:center;color:", ";font-size:", ";cursor:pointer;text-decoration:none;"], function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
});
;// CONCATENATED MODULE: ./src/components/ConferenceLecturer/ConferenceLecturer.tsx








var ConferenceLecturerTemplate = function ConferenceLecturerTemplate(_ref) {
  var _person$titles, _person$titles2, _person$titles3, _person$titles4, _person$links, _person$links2, _person$links3, _person$links4, _person$links5, _person$links6, _person$links7, _person$links8, _person$links9, _person$links10;

  var onClose = _ref.onClose,
      colors = _ref.colors,
      person = _ref.person;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {
          onClick: onClose,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Icon, {
            name: Icon/* Icons.Xmark */.PJ.Xmark,
            colors: colors
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
          children: [person.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
            src: "".concat((0,constants/* getApiURL */.tU)(), "/media/people/").concat(person === null || person === void 0 ? void 0 : person.photo)
          }), !person.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
            src: "/public/avatar.svg"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Name, {
            colors: colors,
            children: [(person === null || person === void 0 ? void 0 : (_person$titles = person.titles) === null || _person$titles === void 0 ? void 0 : _person$titles.before_name) && "".concat(person === null || person === void 0 ? void 0 : (_person$titles2 = person.titles) === null || _person$titles2 === void 0 ? void 0 : _person$titles2.before_name, " "), person.name, " ", person.surname, (person === null || person === void 0 ? void 0 : (_person$titles3 = person.titles) === null || _person$titles3 === void 0 ? void 0 : _person$titles3.after_name) && ", ".concat(person === null || person === void 0 ? void 0 : (_person$titles4 = person.titles) === null || _person$titles4 === void 0 ? void 0 : _person$titles4.after_name)]
          }), (person === null || person === void 0 ? void 0 : person.position) && /*#__PURE__*/(0,jsx_runtime.jsx)(LabelPosition, {
            children: person.position
          }), (person === null || person === void 0 ? void 0 : person.company) && /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
            children: person.company
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Description, {
          dangerouslySetInnerHTML: {
            __html: person === null || person === void 0 ? void 0 : person.annotation
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Social, {
            children: [((_person$links = person.links) === null || _person$links === void 0 ? void 0 : _person$links.facebook) && /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
              href: (_person$links2 = person.links) === null || _person$links2 === void 0 ? void 0 : _person$links2.facebook,
              target: "_blank",
              colors: colors,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Icon, {
                name: Icon/* Icons.Facebook */.PJ.Facebook,
                colors: colors
              })
            }), ((_person$links3 = person.links) === null || _person$links3 === void 0 ? void 0 : _person$links3.linkedin) && /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
              href: (_person$links4 = person.links) === null || _person$links4 === void 0 ? void 0 : _person$links4.linkedin,
              target: "_blank",
              colors: colors,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Icon, {
                name: Icon/* Icons.Linkedin */.PJ.Linkedin,
                colors: colors
              })
            }), ((_person$links5 = person.links) === null || _person$links5 === void 0 ? void 0 : _person$links5.instagram) && /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
              href: (_person$links6 = person.links) === null || _person$links6 === void 0 ? void 0 : _person$links6.instagram,
              target: "_blank",
              colors: colors,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Icon, {
                name: Icon/* Icons.Instagram */.PJ.Instagram,
                colors: colors
              })
            }), ((_person$links7 = person.links) === null || _person$links7 === void 0 ? void 0 : _person$links7.twitter) && /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
              href: (_person$links8 = person.links) === null || _person$links8 === void 0 ? void 0 : _person$links8.twitter,
              target: "_blank",
              colors: colors,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Icon, {
                name: Icon/* Icons.Twitter */.PJ.Twitter,
                colors: colors
              })
            }), ((_person$links9 = person.links) === null || _person$links9 === void 0 ? void 0 : _person$links9.web) && /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
              href: (_person$links10 = person.links) === null || _person$links10 === void 0 ? void 0 : _person$links10.web,
              target: "_blank",
              colors: colors,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer_elements_Icon, {
                name: Icon/* Icons.Laptop */.PJ.Laptop,
                colors: colors
              })
            })]
          })
        })]
      })
    })
  });
};

/* harmony default export */ var ConferenceLecturer = (ConferenceLecturerTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceGuests/ConferenceGuests.elements.tsx



var ConferenceGuests_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuestselements__Wrapper",
  componentId: "sc-aq2rpn-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15));
var ConferenceGuests_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceGuestselements__Title",
  componentId: "sc-aq2rpn-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceGuests_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceGuestselements__TitleSymbol",
  componentId: "sc-aq2rpn-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var Lecturers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuestselements__Lecturers",
  componentId: "sc-aq2rpn-3"
})(["display:flex;flex-direction:column;flex-wrap:wrap;justify-content:center;@media (min-width:", "px){flex-direction:row;}"], theme/* breakpoints.xs */.A.xs);
var Lecturer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuestselements__Lecturer",
  componentId: "sc-aq2rpn-4"
})(["display:flex;flex-direction:column;width:25%;padding:", " ", ";align-items:center;@media (max-width:", "px){width:33.3%;}@media (max-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.xs */.A.xs);
var LecturerImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferenceGuestselements__LecturerImage",
  componentId: "sc-aq2rpn-5"
})(["width:", ";height:", ";border-radius:50%;margin-bottom:", ";", ";"], (0,polished_esm/* rem */.hO)(120), (0,polished_esm/* rem */.hO)(120), (0,polished_esm/* rem */.hO)(0), function (_ref3) {
  var confType = _ref3.confType,
      colors = _ref3.colors;
  return confType === 2 || confType === 3 ? "border: 2px solid ".concat(colors === null || colors === void 0 ? void 0 : colors.colorLink, ";\n        &:hover {\n            border-color: ").concat(colors === null || colors === void 0 ? void 0 : colors.colorLine, ";\n        }") : "";
});
var LecturerName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceGuestselements__LecturerName",
  componentId: "sc-aq2rpn-6"
})(["font-weight:", ";color:", ";padding-top:", ";text-align:center;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
}, (0,polished_esm/* rem */.hO)(20));
var LecturerDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceGuestselements__LecturerDescription",
  componentId: "sc-aq2rpn-7"
})(["font-size:", ";text-align:center;line-height:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20));
var LecturerLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceGuestselements__LecturerLink",
  componentId: "sc-aq2rpn-8"
})(["color:", ";font-size:", ";cursor:pointer;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.conferencePrimary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h5;
});
;// CONCATENATED MODULE: ./src/components/ConferenceGuests/ConferenceGuests.tsx










var ConferenceGuestsTemplate = function ConferenceGuestsTemplate(_ref) {
  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(false),
      isDetailOpen = _useState[0],
      setIsDetailOpen = _useState[1];

  var _useState2 = (0,react.useState)({}),
      selectedPerson = _useState2[0],
      setSelectedPerson = _useState2[1];

  var handlePersonClick = function handlePersonClick(person) {
    setIsDetailOpen(true);
    setSelectedPerson(person);
  };

  var onlyGuests = conf === null || conf === void 0 ? void 0 : conf.lectors.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.type) === 2;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceGuests_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.OPENEVENT),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceGuests_elements_Title, {
      colors: colors,
      children: [t('conference.component.openEvent.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuests_elements_TitleSymbol, {
        colors: colors
      })]
    }), onlyGuests.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturers, {
        children: onlyGuests.map(function (item, index) {
          var _conf$conference, _item$position;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Lecturer, {
            children: [item.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(LecturerLink, {
              onClick: function onClick() {
                return handlePersonClick(item);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LecturerImage, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/people/").concat(item === null || item === void 0 ? void 0 : item.photo),
                colors: colors,
                confType: conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.type
              })
            }), !item.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(LecturerLink, {
              onClick: function onClick() {
                return handlePersonClick(item);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LecturerImage, {
                src: "/public/avatar.svg"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LecturerName, {
              colors: colors,
              children: [item.name, " ", item.surname]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LecturerDescription, {
              children: [item.position, item.company && (item === null || item === void 0 ? void 0 : (_item$position = item.position) === null || _item$position === void 0 ? void 0 : _item$position.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: ", "
              }), item.company]
            })]
          }, "lecturer".concat(index));
        })
      })
    }), isDetailOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer, {
      onClose: function onClose() {
        return setIsDetailOpen(false);
      },
      person: selectedPerson,
      colors: colors
    })]
  });
};

/* harmony default export */ var ConferenceGuests = (ConferenceGuestsTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceGuarantors/ConferenceGuarantors.elements.tsx



var ConferenceGuarantors_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuarantorselements__Wrapper",
  componentId: "sc-mqynmr-0"
})(["padding-top:", ";"], (0,polished_esm/* rem */.hO)(40));
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuarantorselements__Row",
  componentId: "sc-mqynmr-1"
})(["align-items:flex-start;padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:row;}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
var ConferenceGuarantors_elements_Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceGuarantorselements__Label",
  componentId: "sc-mqynmr-2"
})(["min-width:", ";display:block;padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(160), (0,polished_esm/* rem */.hO)(20));
var PatronBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuarantorselements__PatronBlock",
  componentId: "sc-mqynmr-3"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(20));
var LabelPatron = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuarantorselements__LabelPatron",
  componentId: "sc-mqynmr-4"
})(["width:100%;display:block;float:left;padding-bottom:", ";font-weight:bold;text-align:center;"], (0,polished_esm/* rem */.hO)(20));
var ImagePatron = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceGuarantorselements__ImagePatron",
  componentId: "sc-mqynmr-5"
})(["min-width:", ";display:flex;align-items:center;justify-content:center;padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(160), (0,polished_esm/* rem */.hO)(20));
var ConferenceGuarantors_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceGuarantorselements__Title",
  componentId: "sc-mqynmr-6"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceGuarantors_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceGuarantorselements__TitleSymbol",
  componentId: "sc-mqynmr-7"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferenceGuarantors_elements_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferenceGuarantorselements__Image",
  componentId: "sc-mqynmr-8"
})(["padding-right:", ";height:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(20));
var ConferenceGuarantors_elements_Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferenceGuarantorselements__Link",
  componentId: "sc-mqynmr-9"
})([""]);
;// CONCATENATED MODULE: ./src/components/ConferenceGuarantors/ConferenceGuarantors.tsx








var ConferenceGuarantorsTemplate = function ConferenceGuarantorsTemplate(_ref) {
  var garantPartners = _ref.garantPartners,
      patronPartners = _ref.patronPartners,
      colors = _ref.colors;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceGuarantors_elements_Wrapper, {
    children: [patronPartners.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceGuarantors_elements_Title, {
        colors: colors,
        children: [t('conference.general.patron'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuarantors_elements_TitleSymbol, {
          colors: colors
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Row, {
        children: patronPartners.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(PatronBlock, {
            children: [item.description && /*#__PURE__*/(0,jsx_runtime.jsx)(LabelPatron, {
              children: item.description
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImagePatron, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuarantors_elements_Link, {
                href: item.url,
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuarantors_elements_Image, {
                  src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                  alt: item.photo,
                  title: item.name
                })
              })
            })]
          }, "headpartner".concat(index));
        })
      })]
    }), garantPartners.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceGuarantors_elements_Title, {
        colors: colors,
        children: [t('conference.general.garants'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuarantors_elements_TitleSymbol, {
          colors: colors
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Row, {
        children: garantPartners.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuarantors_elements_Link, {
            href: item.url,
            target: "_blank",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuarantors_elements_Image, {
              src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
              alt: item.photo,
              title: item.name
            })
          }, "headgarant".concat(index));
        })
      })]
    })]
  });
};

/* harmony default export */ var ConferenceGuarantors = (ConferenceGuarantorsTemplate);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/moment/locale/sk.js
var sk = __webpack_require__(64249);
;// CONCATENATED MODULE: ./src/components/ConferenceHeader/ConferenceHeader.elements.tsx



var ConferenceHeader_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceHeaderelements__Wrapper",
  componentId: "sc-19e3gjb-0"
})(["position:relative;height:", ";overflow:hidden;border-bottom-left-radius:", ";border-bottom-right-radius:", ";display:flex;flex-direction:column;"], (0,polished_esm/* rem */.hO)(595), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(12));
var ConferenceHeader_elements_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferenceHeaderelements__Image",
  componentId: "sc-19e3gjb-1"
})(["position:absolute;height:", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], (0,polished_esm/* rem */.hO)(595), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(12));
var ConferenceHeader_elements_Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceHeaderelements__Label",
  componentId: "sc-19e3gjb-2"
})(["display:block;color:", ";position:relative;padding:", " ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(30));
var ConferenceHeader_elements_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "ConferenceHeaderelements__Title",
  componentId: "sc-19e3gjb-3"
})(["display:block;color:", ";font-weight:", ";position:relative;font-size:", ";line-height:", ";padding:", " ", ";@media (min-width:", "px){font-size:", ";line-height:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.xs */.A.xs, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h2;
}, (0,polished_esm/* rem */.hO)(45));
var ConferenceHeader_elements_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceHeaderelements__Date",
  componentId: "sc-19e3gjb-4"
})(["color:", ";position:relative;display:block;font-size:", ";padding:", " ", " ", ";font-weight:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.white;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(5), function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeights.textBold;
}, theme/* breakpoints.xs */.A.xs, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.h3;
});
var Place = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceHeaderelements__Place",
  componentId: "sc-19e3gjb-5"
})(["color:", ";position:relative;display:block;padding:0 ", ";@media (min-width:", "px){padding:0 ", " ", " ", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(30));
var Buttons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceHeaderelements__Buttons",
  componentId: "sc-19e3gjb-6"
})(["position:relative;padding:", " ", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(30));
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ConferenceHeaderelements__Button",
  componentId: "sc-19e3gjb-7"
})(["border:none;border-radius:", ";font-weight:", ";padding:0 ", ";height:", ";margin-right:", ";margin-bottom:", ";cursor:pointer;box-shadow:0 0 10px ", ";"], (0,polished_esm/* rem */.hO)(4), function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.dark;
});
var ButtonTicket = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
  displayName: "ConferenceHeaderelements__ButtonTicket",
  componentId: "sc-19e3gjb-8"
})(["background:", ";color:", ";"], function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorButton;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.white;
});
var ButtonPartner = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
  displayName: "ConferenceHeaderelements__ButtonPartner",
  componentId: "sc-19e3gjb-9"
})(["background:", ";color:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.white;
}, function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLink;
});
var ConferenceHeader_elements_Lecturers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceHeaderelements__Lecturers",
  componentId: "sc-19e3gjb-10"
})(["color:", ";position:relative;margin-top:auto;padding:", " ", " ", " ", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30));
var ConferenceHeader_elements_Lecturer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceHeaderelements__Lecturer",
  componentId: "sc-19e3gjb-11"
})(["float:left;"]);
var LecturersTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceHeaderelements__LecturersTitle",
  componentId: "sc-19e3gjb-12"
})(["display:block;font-size:", ";font-weight:", ";padding-bottom:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontSizes.h6;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10));
var LecturersList = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceHeaderelements__LecturersList",
  componentId: "sc-19e3gjb-13"
})([""]);
var ConferenceHeader_elements_LecturerName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceHeaderelements__LecturerName",
  componentId: "sc-19e3gjb-14"
})([""]);
var LecturerSurname = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceHeaderelements__LecturerSurname",
  componentId: "sc-19e3gjb-15"
})(["font-weight:", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontWeights.textBold;
});
var LecturerNext = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceHeaderelements__LecturerNext",
  componentId: "sc-19e3gjb-16"
})(["font-weight:", ";float:left;"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeights.textBold;
});
;// CONCATENATED MODULE: ./src/components/ConferenceHeader/ConferenceHeader.tsx














var ConferenceHeaderTemplate = function ConferenceHeaderTemplate(_ref) {
  var _conf$conference, _conf$conference2, _conf$conference3, _conf$conference4, _conf$conference5, _conf$conference6, _venues$, _venues$2, _conf$conference7;

  var colors = _ref.colors,
      conf = _ref.conf,
      setActiveSection = _ref.setActiveSection;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });

  var _useState = (0,react.useState)(null),
      eventDate = _useState[0],
      setEventDate = _useState[1];

  var _useState2 = (0,react.useState)(false),
      timeToShowOnline = _useState2[0],
      setTimeToShowOnline = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      timeToShowRecord = _useState3[0],
      setTimeToShowRecord = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isLoggedIn = _useState4[0],
      setIsLoggedIn = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      venues = _useState5[0],
      setVenues = _useState5[1];

  var inHeroLectors = conf === null || conf === void 0 ? void 0 : conf.lectors.filter(function (item) {
    return item === null || item === void 0 ? void 0 : item.inHero;
  });
  var garantPartners = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return item.isGarant;
  });
  var patronPartners = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return item.isPatron;
  });
  var isSetTicket = conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.components.filter(function (item) {
    return item.type === 4;
  });
  var isSetVideo = conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.components.filter(function (item) {
    return item.type === 10;
  });
  var isSetOnlineSection = conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : _conf$conference3.components.filter(function (item) {
    return item.type === 18;
  });
  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);
  (0,react.useEffect)(function () {
    if (conf !== null && conf !== void 0 && conf.dates) {
      setEventDate(conf === null || conf === void 0 ? void 0 : conf.dates);
    }
  }, []);
  (0,react.useEffect)(function () {
    if (eventDate) {
      var fromDates = eventDate.map(function (item) {
        return item.date.from;
      });
      var min = fromDates.reduce(function (a, b) {
        return a < b ? a : b;
      });
      var toDates = eventDate.map(function (item) {
        return item.date.to;
      });
      var max = toDates.reduce(function (a, b) {
        return a > b ? a : b;
      });
      var videos = [];

      for (var x = 0; x < eventDate.length; x++) {
        for (var z = 0; z < eventDate[x].videos.length; z++) {
          var _eventDate$x;

          videos.push((_eventDate$x = eventDate[x]) === null || _eventDate$x === void 0 ? void 0 : _eventDate$x.videos[z]);
        }
      }

      if (moment_default()() >= moment_default()(min).subtract(1, 'h') && moment_default()() <= moment_default()(max)) {
        setTimeToShowOnline(true);
      } else {
        setTimeToShowOnline(false);
      }

      if (moment_default()() > moment_default()(max) && videos.length > 0 && moment_default()() <= moment_default()(max).subtract(-30, 'd')) {
        setTimeToShowRecord(true);
      } else {
        setTimeToShowRecord(false);
      }

      for (var _x = 0; _x < eventDate.length; _x++) {
        for (var _z = 0; _z < eventDate[_x].venues.length; _z++) {
          var _eventDate$_x;

          venues.push((_eventDate$_x = eventDate[_x]) === null || _eventDate$_x === void 0 ? void 0 : _eventDate$_x.venues[_z]);
        }
      }

      var venuesUnique = venues.filter(function (value, index, self) {
        return self.map(function (x) {
          return x._key;
        }).indexOf(value._key) == index;
      });
      setVenues(venuesUnique);
    }
  }, [eventDate]);

  var getEventDateForConference = function getEventDateForConference() {
    var fromDates = eventDate.map(function (item) {
      return item.date.from;
    });
    var min = fromDates.reduce(function (a, b) {
      return a < b ? a : b;
    });
    var minStr = moment_default()(min).format('D. M. ');
    var toDates = eventDate.map(function (item) {
      return item.date.to;
    });
    var max = toDates.reduce(function (a, b) {
      return a > b ? a : b;
    });
    var maxStr = moment_default()(max).format('D. M. YYYY');
    var nonComplet = "".concat(moment_default()(min).format('MMMM'), " ").concat(moment_default()(min).format('YYYY'));
    return max ? /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader_elements_Date, {
      children: moment_default()(min).format('D. M. YYYY') === moment_default()(max).format('D. M. YYYY') ? "".concat(moment_default()(max).format('D. M. YYYY')) : "".concat(moment_default()(min).format('D. M. '), " \u2013 ").concat(moment_default()(max).format('D. M. YYYY'))
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader_elements_Date, {
      children: nonComplet
    });
  };

  var handleMenuClick = function handleMenuClick(id) {
    var top = document.getElementById(id).offsetTop;
    setActiveSection(id);
    return window.scrollTo({
      top: top - 80,
      behavior: 'smooth'
    });
  };

  var handleOnlineClick = function handleOnlineClick(token) {
    window.open("https://konferencie.pp.sk/login?auth=".concat(token), '_blank');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceHeader_elements_Wrapper, {
      id: "confSection".concat(COMPONENT_TYPE.HERO),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader_elements_Image, {
        src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/conference/").concat(conf === null || conf === void 0 ? void 0 : (_conf$conference4 = conf.conference) === null || _conf$conference4 === void 0 ? void 0 : _conf$conference4.photo, "?size=1024")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader_elements_Label, {
        children: conf === null || conf === void 0 ? void 0 : (_conf$conference5 = conf.conference) === null || _conf$conference5 === void 0 ? void 0 : _conf$conference5.sub_title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader_elements_Title, {
        onClick: getEventDateForConference,
        children: conf === null || conf === void 0 ? void 0 : (_conf$conference6 = conf.conference) === null || _conf$conference6 === void 0 ? void 0 : _conf$conference6.title
      }), eventDate && getEventDateForConference(), venues.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Place, {
        children: [(_venues$ = venues[0]) === null || _venues$ === void 0 ? void 0 : _venues$.city, ", ", (_venues$2 = venues[0]) === null || _venues$2 === void 0 ? void 0 : _venues$2.name]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Buttons, {
        children: [(isSetTicket.length > 0 && !timeToShowOnline || isSetTicket.length > 0 && !(conf !== null && conf !== void 0 && conf.token) && timeToShowOnline) && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonTicket, {
          colors: colors,
          onClick: function onClick() {
            return handleMenuClick("confSection4");
          },
          children: t('conference.general.tickets')
        }), isSetOnlineSection.length == 1 && (conf === null || conf === void 0 ? void 0 : conf.token) && timeToShowOnline && (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonTicket, {
          colors: colors,
          onClick: function onClick() {
            return handleMenuClick("confSection18");
          },
          children: t('conference.general.onlineTransmission')
        }), isSetVideo && !timeToShowOnline && timeToShowRecord && isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonTicket, {
          colors: colors,
          onClick: function onClick() {
            return handleMenuClick("confSection10");
          },
          children: t('conference.general.Record')
        }), (conf === null || conf === void 0 ? void 0 : (_conf$conference7 = conf.conference) === null || _conf$conference7 === void 0 ? void 0 : _conf$conference7.showPartnership) && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonPartner, {
          colors: colors,
          onClick: function onClick() {
            return handleMenuClick("confSection13");
          },
          children: t('conference.component.partnership.buttontitle')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader_elements_Lecturers, {
        children: inHeroLectors.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LecturersTitle, {
            children: [t('conference.component.lecturers.title'), ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LecturersList, {
            children: [inHeroLectors.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceHeader_elements_Lecturer, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader_elements_LecturerName, {
                  children: item.name
                }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(LecturerSurname, {
                  children: item.surname
                }), index + 1 !== inHeroLectors.length && /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceHeader_elements_LecturerName, {
                  children: [',', "\xA0"]
                })]
              }, "lectureName".concat(index));
            }), inHeroLectors.length < (conf === null || conf === void 0 ? void 0 : conf.lectors.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(LecturerSurname, {
              children: "\xA0a dal\u0161\xED"
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuarantors, {
      garantPartners: garantPartners,
      patronPartners: patronPartners,
      colors: colors,
      conf: conf
    })]
  });
};

/* harmony default export */ var ConferenceHeader = (ConferenceHeaderTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceInvitations/ConferenceInvitations.elements.tsx



var ConferenceInvitations_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceInvitationselements__Wrapper",
  componentId: "sc-1jegnz1-0"
})(["padding:", " 0 ", " 0;border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
var ConferenceInvitations_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceInvitationselements__Title",
  componentId: "sc-1jegnz1-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceInvitations_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceInvitationselements__TitleSymbol",
  componentId: "sc-1jegnz1-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var Invitations = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceInvitationselements__Invitations",
  componentId: "sc-1jegnz1-3"
})(["display:flex;flex-direction:column;flex-wrap:wrap;justify-content:center;@media (min-width:", "px){flex-direction:row;}"], theme/* breakpoints.xs */.A.xs);
var Invitation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceInvitationselements__Invitation",
  componentId: "sc-1jegnz1-4"
})(["display:flex;flex-direction:column;width:50%;height:250px;padding:", " ", ";align-items:center;@media (max-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm);
var EmbedContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceInvitationselements__EmbedContent",
  componentId: "sc-1jegnz1-5"
})(["position:relative;display:block;width:100%;height:100%;padding:0;overflow:hidden;"]);
var Embed = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "ConferenceInvitationselements__Embed",
  componentId: "sc-1jegnz1-6"
})(["position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0;"]);
;// CONCATENATED MODULE: ./src/components/ConferenceInvitations/ConferenceInvitations.tsx








var ConferenceInvitationsTemplate = function ConferenceInvitationsTemplate(_ref) {
  var _conf$conference, _conf$conference$vide, _conf$conference2, _conf$conference2$vid;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceInvitations_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.INVITATIONS),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceInvitations_elements_Title, {
      colors: colors,
      children: [t('conference.component.videoInventions.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceInvitations_elements_TitleSymbol, {
        colors: colors
      })]
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : (_conf$conference$vide = _conf$conference.video_invitations) === null || _conf$conference$vide === void 0 ? void 0 : _conf$conference$vide.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Invitations, {
          children: conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : (_conf$conference2$vid = _conf$conference2.video_invitations) === null || _conf$conference2$vid === void 0 ? void 0 : _conf$conference2$vid.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Invitation, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(EmbedContent, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Embed, {
                  src: item === null || item === void 0 ? void 0 : item.url,
                  title: "Invite video",
                  allowFullScreen: true
                })
              })
            }, "".concat(index));
          })
        })
      })
    })]
  });
};

/* harmony default export */ var ConferenceInvitations = (ConferenceInvitationsTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceLecturers/ConferenceLecturers.elements.tsx



var ConferenceLecturers_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerselements__Wrapper",
  componentId: "sc-lxroz7-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15));
var ConferenceLecturers_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceLecturerselements__Title",
  componentId: "sc-lxroz7-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceLecturers_elements_Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerselements__Description",
  componentId: "sc-lxroz7-2"
})(["padding-bottom:", ";display:flex;position:relative;"], (0,polished_esm/* rem */.hO)(25));
var ConferenceLecturers_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceLecturerselements__TitleSymbol",
  componentId: "sc-lxroz7-3"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferenceLecturers_elements_Lecturers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerselements__Lecturers",
  componentId: "sc-lxroz7-4"
})(["display:flex;flex-direction:column;flex-wrap:wrap;justify-content:center;@media (min-width:", "px){flex-direction:row;}"], theme/* breakpoints.xs */.A.xs);
var ConferenceLecturers_elements_Lecturer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceLecturerselements__Lecturer",
  componentId: "sc-lxroz7-5"
})(["display:flex;flex-direction:column;width:25%;padding:", " ", ";align-items:center;@media (max-width:", "px){width:33.3%;}@media (max-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.xs */.A.xs);
var ConferenceLecturers_elements_LecturerImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferenceLecturerselements__LecturerImage",
  componentId: "sc-lxroz7-6"
})(["width:", ";height:", ";border-radius:50%;margin-bottom:", ";", ";"], (0,polished_esm/* rem */.hO)(120), (0,polished_esm/* rem */.hO)(120), (0,polished_esm/* rem */.hO)(0), function (_ref3) {
  var confType = _ref3.confType,
      colors = _ref3.colors;
  return confType === 2 || confType === 3 ? "border: 2px solid ".concat(colors === null || colors === void 0 ? void 0 : colors.colorLink, ";\n        &:hover {\n            border-color: ").concat(colors === null || colors === void 0 ? void 0 : colors.colorLine, ";\n        }") : "";
});
var ConferenceLecturers_elements_LecturerName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceLecturerselements__LecturerName",
  componentId: "sc-lxroz7-7"
})(["font-weight:", ";color:", ";padding-top:", ";text-align:center;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
}, (0,polished_esm/* rem */.hO)(20));
var ConferenceLecturers_elements_LecturerDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceLecturerselements__LecturerDescription",
  componentId: "sc-lxroz7-8"
})(["font-size:", ";text-align:center;line-height:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20));
var ConferenceLecturers_elements_LecturerLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceLecturerselements__LecturerLink",
  componentId: "sc-lxroz7-9"
})(["color:", ";font-size:", ";cursor:pointer;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.conferencePrimary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h5;
});
;// CONCATENATED MODULE: ./src/components/ConferenceLecturers/ConferenceLecturers.tsx










var ConferenceLecturersTemplate = function ConferenceLecturersTemplate(_ref) {
  var _conf$conference, _conf$conference$reda;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(false),
      isDetailOpen = _useState[0],
      setIsDetailOpen = _useState[1];

  var _useState2 = (0,react.useState)({}),
      selectedPerson = _useState2[0],
      setSelectedPerson = _useState2[1];

  var handlePersonClick = function handlePersonClick(person) {
    setIsDetailOpen(true);
    setSelectedPerson(person);
  };

  var onlyLecturers = conf === null || conf === void 0 ? void 0 : conf.lectors.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.type) === 1;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceLecturers_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.PERSONS),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceLecturers_elements_Title, {
      colors: colors,
      children: [t('conference.component.lecturers.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers_elements_TitleSymbol, {
        colors: colors
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers_elements_Description, {
      children: conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : (_conf$conference$reda = _conf$conference.redactorTexts) === null || _conf$conference$reda === void 0 ? void 0 : _conf$conference$reda.lectorDescription
    }), onlyLecturers.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers_elements_Lecturers, {
        children: onlyLecturers.map(function (item, index) {
          var _conf$conference2, _item$titles, _item$titles2, _item$titles3, _item$titles4, _item$position;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceLecturers_elements_Lecturer, {
            children: [item.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers_elements_LecturerLink, {
              onClick: function onClick() {
                return handlePersonClick(item);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers_elements_LecturerImage, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/people/").concat(item === null || item === void 0 ? void 0 : item.photo),
                colors: colors,
                confType: conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.type
              })
            }), !item.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers_elements_LecturerLink, {
              onClick: function onClick() {
                return handlePersonClick(item);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers_elements_LecturerImage, {
                src: "/public/avatar.svg"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceLecturers_elements_LecturerName, {
              colors: colors,
              children: [(item === null || item === void 0 ? void 0 : (_item$titles = item.titles) === null || _item$titles === void 0 ? void 0 : _item$titles.before_name) && "".concat(item === null || item === void 0 ? void 0 : (_item$titles2 = item.titles) === null || _item$titles2 === void 0 ? void 0 : _item$titles2.before_name, " "), item.name, " ", item.surname, (item === null || item === void 0 ? void 0 : (_item$titles3 = item.titles) === null || _item$titles3 === void 0 ? void 0 : _item$titles3.after_name) && ", ".concat(item === null || item === void 0 ? void 0 : (_item$titles4 = item.titles) === null || _item$titles4 === void 0 ? void 0 : _item$titles4.after_name)]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceLecturers_elements_LecturerDescription, {
              children: [item.position, item.company && (item === null || item === void 0 ? void 0 : (_item$position = item.position) === null || _item$position === void 0 ? void 0 : _item$position.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: ", "
              }), item.company]
            })]
          }, "lecturer".concat(index));
        })
      })
    }), isDetailOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturer, {
      onClose: function onClose() {
        return setIsDetailOpen(false);
      },
      person: selectedPerson,
      colors: colors
    })]
  });
};

/* harmony default export */ var ConferenceLecturers = (ConferenceLecturersTemplate);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/utils/cart.utils.ts
var cart_utils = __webpack_require__(80018);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
;// CONCATENATED MODULE: ./src/components/ConferenceOrderTickets/ConferenceOrderTickets.elements.tsx



var ConferenceOrderTickets_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__Wrapper",
  componentId: "sc-114etfw-0"
})(["padding:", " ", " ", " ", ";background:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorLightest;
});
var ConferenceOrderTickets_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__Title",
  componentId: "sc-114etfw-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  return props.colors.colorTitle;
});
var ConferenceOrderTickets_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__TitleSymbol",
  componentId: "sc-114etfw-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  return props.colors.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var TicketsHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__TicketsHeader",
  componentId: "sc-114etfw-3"
})(["background:", ";display:flex;flex-direction:row;text-align:center;padding-bottom:", ";width:100%;@media (max-width:", "px){padding-top:", ";padding-bottom:", ";}@media (min-width:", "px){", ";}"], function (props) {
  return props.colors.colorLightest;
}, (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.xs */.A.xs, function (_ref3) {
  var index = _ref3.index;
  return index === 0 ? "display: flex" : "display: none";
});
var Ticket = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__Ticket",
  componentId: "sc-114etfw-4"
})(["display:flex;flex-direction:row;text-align:center;padding-bottom:", ";width:100%;flex-direction:row;@media (max-width:", "px){", ";}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.xs */.A.xs, function (_ref4) {
  var footer = _ref4.footer;
  return footer ? "flex-direction: row" : "flex-direction: column";
});
var TicketDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__TicketDetails",
  componentId: "sc-114etfw-5"
})(["display:flex;flex-direction:row;"]);
var TicketContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__TicketContent",
  componentId: "sc-114etfw-6"
})(["display:flex;flex-direction:column;"]);
var TicketTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__TicketTitle",
  componentId: "sc-114etfw-7"
})(["text-align:left;font-weight:", ";width:", ";display:flex;align-items:end;justify-content:start;@media (max-width:", "px){", ";padding-top:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(300), theme/* breakpoints.xs */.A.xs, function (_ref6) {
  var footer = _ref6.footer;
  return footer ? "width: 0" : "width: ".concat((0,polished_esm/* rem */.hO)(300));
}, (0,polished_esm/* rem */.hO)(15));
var TicketPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__TicketPrice",
  componentId: "sc-114etfw-8"
})(["width:", ";display:flex;align-items:center;justify-content:center;", ";", ";", ";"], (0,polished_esm/* rem */.hO)(140), function (_ref7) {
  var footer = _ref7.footer,
      theme = _ref7.theme;
  return footer ? "border-top: 1px solid ".concat(theme.colors.secondaryGrey) : "";
}, function (_ref8) {
  var footer = _ref8.footer;
  return footer ? "padding: ".concat((0,polished_esm/* rem */.hO)(10), " 0") : "";
}, function (_ref9) {
  var footer = _ref9.footer,
      theme = _ref9.theme;
  return footer ? "font-weight: ".concat(theme.fontWeights.textBold, ";") : "";
});
var TicketButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__TicketButtons",
  componentId: "sc-114etfw-9"
})(["border-radius:", ";cursor:pointer;display:flex;flex-direction:row;color:", ";font-weight:", ";width:", ";", ";", ";", ";"], (0,polished_esm/* rem */.hO)(4), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.black;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(110), function (_ref12) {
  var footer = _ref12.footer,
      theme = _ref12.theme;
  return footer ? "background: none" : "background: ".concat(theme.colors.white);
}, function (_ref13) {
  var footer = _ref13.footer,
      theme = _ref13.theme;
  return footer ? "border-top: 1px solid ".concat(theme.colors.secondaryGrey) : "border: 1px solid ".concat(theme.colors.secondaryGrey);
}, function (prop) {
  return prop.footer ? "border-radius: ".concat((0,polished_esm/* rem */.hO)(0), ";") : "border-radius: ".concat((0,polished_esm/* rem */.hO)(4));
});
var TicketButtonsHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__TicketButtonsHeader",
  componentId: "sc-114etfw-10"
})(["border-radius:", ";display:flex;flex-direction:row;color:", ";width:", ";background:none;border:none;justify-content:center;"], (0,polished_esm/* rem */.hO)(4), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(110));
var Plus = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__Plus",
  componentId: "sc-114etfw-11"
})(["padding:", " ", ";font-size:", ";display:flex;align-items:center;justify-content:center;"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSizes.h5;
});
var Minus = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__Minus",
  componentId: "sc-114etfw-12"
})(["padding:", " ", ";font-size:", ";display:flex;align-items:center;justify-content:center;"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontSizes.h5;
});
var Count = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__Count",
  componentId: "sc-114etfw-13"
})(["padding:0 ", ";font-size:", ";display:flex;align-items:center;justify-content:center;"], (0,polished_esm/* rem */.hO)(10), function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontSizes.h7;
});
var OrderForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__OrderForm",
  componentId: "sc-114etfw-14"
})(["display:flex;flex-direction:column;text-align:left;padding-bottom:", ";width:100%;"], (0,polished_esm/* rem */.hO)(25));
var OrderFormPerson = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__OrderFormPerson",
  componentId: "sc-114etfw-15"
})(["display:flex;flex-direction:row;text-align:left;padding-bottom:", ";width:100%;@media (max-width:", "px){flex-direction:column;}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var OrderFormCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__OrderFormCompany",
  componentId: "sc-114etfw-16"
})(["display:flex;flex-direction:row;text-align:left;padding-bottom:", ";width:100%;@media (max-width:", "px){flex-direction:column;}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var OrderFormDiscount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__OrderFormDiscount",
  componentId: "sc-114etfw-17"
})(["display:flex;flex-direction:row;text-align:left;margin-bottom:", ";width:100%;@media (max-width:", "px){flex-direction:column;align-items:flex-start;gap:", ";}"], (0,polished_esm/* rem */.hO)(50), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(15));
var ConferenceOrderTickets_elements_Col1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__Col1",
  componentId: "sc-114etfw-18"
})(["display:flex;flex-direction:column;text-align:left;padding-bottom:", ";width:100%;"], (0,polished_esm/* rem */.hO)(25));
var ConferenceOrderTickets_elements_Col2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__Col2",
  componentId: "sc-114etfw-19"
})(["display:flex;flex-direction:column;text-align:left;padding-bottom:", ";width:100%;"], (0,polished_esm/* rem */.hO)(25));
var OrderFormTickets = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__OrderFormTickets",
  componentId: "sc-114etfw-20"
})([""]);
var OrderGeneralText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceOrderTicketselements__OrderGeneralText",
  componentId: "sc-114etfw-21"
})([""]);
var OrderTitleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__OrderTitleText",
  componentId: "sc-114etfw-22"
})(["font-weight:", ";font-size:", ";padding-bottom:", ";padding-top:", ";@media (max-width:", "px){padding-bottom:", ";}"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontWeights.textBold;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(20));
var InputSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__InputSection",
  componentId: "sc-114etfw-23"
})(["position:relative;margin:", " ", " ", " ", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(0));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ConferenceOrderTicketselements__Input",
  componentId: "sc-114etfw-24"
})(["height:", ";padding:", " ", ";border:1px solid ", ";width:", ";border-radius:", ";", "}&.error{border-color:", ";}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(15), function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(320), (0,polished_esm/* rem */.hO)(4), function (prop) {
  return prop.marginBottom ? "margin-bottom: ".concat((0,polished_esm/* rem */.hO)(prop.marginBottom), " !important") : '';
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.danger;
});
var InputCount = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ConferenceOrderTicketselements__InputCount",
  componentId: "sc-114etfw-25"
})(["border:none;width:", ";text-align:center;"], (0,polished_esm/* rem */.hO)(30));
var Select = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
  displayName: "ConferenceOrderTicketselements__Select",
  componentId: "sc-114etfw-26"
})(["height:", ";border:", " solid ", ";outline:1px solid ", ";width:", ";color:", ";border-radius:", ";margin-bottom:", ";margin-top:", ";"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(12), function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.white;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(320), function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(4), function (props) {
  return props.bottom ? "".concat((0,polished_esm/* rem */.hO)(props.bottom)) : 0;
}, function (props) {
  return props.top ? "".concat((0,polished_esm/* rem */.hO)(props.top)) : 0;
});
var Option = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
  displayName: "ConferenceOrderTicketselements__Option",
  componentId: "sc-114etfw-27"
})([""]);
var Error = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__Error",
  componentId: "sc-114etfw-28"
})(["color:", ";font-size:", ";position:absolute;left:0;bottom:", ";"], function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.danger;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.fontSizes.textSmall;
}, function (props) {
  return props.bottom ? "-".concat((0,polished_esm/* rem */.hO)(props.bottom)) : "-".concat((0,polished_esm/* rem */.hO)(14));
});
var CheckboxLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__CheckboxLabel",
  componentId: "sc-114etfw-29"
})(["font-size:", ";a{color:", ";}"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.fontSizes.h7;
}, function (props) {
  var _props$colors2;

  return props === null || props === void 0 ? void 0 : (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLink;
});
var Agreements = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__Agreements",
  componentId: "sc-114etfw-30"
})([""]);
var DiscountLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__DiscountLabel",
  componentId: "sc-114etfw-31"
})(["display:flex;align-items:center;justify-content:center;margin-right:", ";"], (0,polished_esm/* rem */.hO)(10));
var DiscountCode = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__DiscountCode",
  componentId: "sc-114etfw-32"
})([""]);
var ConferenceOrderTickets_elements_Buttons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceOrderTicketselements__Buttons",
  componentId: "sc-114etfw-33"
})(["position:relative;text-align:center;padding:", " ", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(30));
var ButtonSendForm = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ConferenceOrderTicketselements__ButtonSendForm",
  componentId: "sc-114etfw-34"
})(["background:", ";border:none;color:", ";border-radius:", ";font-weight:", ";padding:0 ", ";height:", ";margin-right:", ";margin-bottom:", ";cursor:pointer;box-shadow:0 0 10px ", ";&:disabled{opacity:0.5;}"], function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorButton;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(4), function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref30) {
  var theme = _ref30.theme;
  return theme.colors.dark;
});
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceOrderTicketselements__SuccessMessage",
  componentId: "sc-114etfw-35"
})(["color:", ";"], function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.primary;
});
;// CONCATENATED MODULE: ./src/components/ConferenceOrderTickets/ConferenceOrderTicket.tsx












var ConferenceOrderTicketTemplate = function ConferenceOrderTicketTemplate(_ref) {
  var _ticket$date3, _date$modules, _date$eventDate, _date$eventDate2, _date$eventDate3, _nameInputRef$current8;

  var colors = _ref.colors,
      ticket = _ref.ticket,
      index = _ref.index,
      handleSetCountTickets = _ref.handleSetCountTickets;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(),
      date = _useState[0],
      setDate = _useState[1];

  var _useState2 = (0,react.useState)(0),
      totalPrice = _useState2[0],
      setTotalPrice = _useState2[1];

  var nameInputRef = (0,react.useRef)();

  var loadDateByKey = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dateKey) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return calendar_service/* calendarApi.getDateData */.w.getDateData(dateKey);

            case 2:
              response = _context.sent;
              setDate(response.data);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadDateByKey(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var _ticket$date;

    if (ticket !== null && ticket !== void 0 && (_ticket$date = ticket.date) !== null && _ticket$date !== void 0 && _ticket$date._key) {
      var _ticket$date2;

      loadDateByKey(ticket === null || ticket === void 0 ? void 0 : (_ticket$date2 = ticket.date) === null || _ticket$date2 === void 0 ? void 0 : _ticket$date2._key);
    }
  }, [ticket === null || ticket === void 0 ? void 0 : (_ticket$date3 = ticket.date) === null || _ticket$date3 === void 0 ? void 0 : _ticket$date3._key]);
  var priceTicket = date === null || date === void 0 ? void 0 : (_date$modules = date.modules) === null || _date$modules === void 0 ? void 0 : _date$modules.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.type) === 0;
  });
  var a = moment_default()(date === null || date === void 0 ? void 0 : (_date$eventDate = date.eventDate) === null || _date$eventDate === void 0 ? void 0 : _date$eventDate.to);
  var b = moment_default()(date === null || date === void 0 ? void 0 : (_date$eventDate2 = date.eventDate) === null || _date$eventDate2 === void 0 ? void 0 : _date$eventDate2.from);
  var diffDays = a.diff(b, 'days') + 1;

  var handlePlus = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _nameInputRef$current, _nameInputRef$current2, _priceTicket$, _nameInputRef$current3, _ticket$date4;

      var totalPrice;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              nameInputRef.current.value = String(Number(nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current = nameInputRef.current) === null || _nameInputRef$current === void 0 ? void 0 : _nameInputRef$current.value) + 1);
              totalPrice = Number(nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) * Number((_priceTicket$ = priceTicket[0]) === null || _priceTicket$ === void 0 ? void 0 : _priceTicket$.price_with_vat);
              setTotalPrice(totalPrice);
              handleSetCountTickets({
                count: Number(nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value),
                key: ticket === null || ticket === void 0 ? void 0 : (_ticket$date4 = ticket.date) === null || _ticket$date4 === void 0 ? void 0 : _ticket$date4._key,
                name: ticket === null || ticket === void 0 ? void 0 : ticket.name,
                totalPrice: totalPrice
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handlePlus() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleMinus = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var _nameInputRef$current4;

      var _nameInputRef$current5, _nameInputRef$current6, _priceTicket$2, _nameInputRef$current7, _ticket$date5, _totalPrice;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (Number(nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current4 = nameInputRef.current) === null || _nameInputRef$current4 === void 0 ? void 0 : _nameInputRef$current4.value) > 0) {
                nameInputRef.current.value = String(Number(nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current5 = nameInputRef.current) === null || _nameInputRef$current5 === void 0 ? void 0 : _nameInputRef$current5.value) - 1);
                _totalPrice = Number(nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current6 = nameInputRef.current) === null || _nameInputRef$current6 === void 0 ? void 0 : _nameInputRef$current6.value) * Number((_priceTicket$2 = priceTicket[0]) === null || _priceTicket$2 === void 0 ? void 0 : _priceTicket$2.price_with_vat);
                setTotalPrice(_totalPrice);
                handleSetCountTickets({
                  count: Number(nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current7 = nameInputRef.current) === null || _nameInputRef$current7 === void 0 ? void 0 : _nameInputRef$current7.value),
                  key: ticket === null || ticket === void 0 ? void 0 : (_ticket$date5 = ticket.date) === null || _ticket$date5 === void 0 ? void 0 : _ticket$date5._key,
                  name: ticket === null || ticket === void 0 ? void 0 : ticket.name,
                  totalPrice: _totalPrice
                });
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleMinus() {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ticket, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TicketTitle, {
      children: [ticket.name, " ", diffDays > 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["(", diffDays, " ", t('conference.general.countDays'), ")"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TicketsHeader, {
        colors: colors,
        index: index,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TicketPrice, {
          children: t('conference.general.priceVat')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketButtonsHeader, {
          children: t('conference.general.count')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketPrice, {
          children: t('conference.general.priceVatTotal')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketDetails, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TicketPrice, {
          children: (priceTicket === null || priceTicket === void 0 ? void 0 : priceTicket.length) > 0 && (date === null || date === void 0 ? void 0 : (_date$eventDate3 = date.eventDate) === null || _date$eventDate3 === void 0 ? void 0 : _date$eventDate3.state) === 0 ? "".concat((0,cart_utils/* formatMoneyToCZK */.DM)(priceTicket[0].price_with_vat), " K\u010D") : '-'
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketButtons, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Minus, {
            onClick: handleMinus,
            children: "-"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Count, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(InputCount, {
              ref: nameInputRef,
              value: (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current8 = nameInputRef.current) === null || _nameInputRef$current8 === void 0 ? void 0 : _nameInputRef$current8.value) || 0
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Plus, {
            onClick: handlePlus,
            children: "+"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketPrice, {
          children: [(0,cart_utils/* formatMoneyToCZK */.DM)(Math.round(totalPrice * 100) / 100), " K\u010D"]
        })]
      })]
    })]
  });
};

/* harmony default export */ var ConferenceOrderTicket = (ConferenceOrderTicketTemplate);
// EXTERNAL MODULE: ./src/ui/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(26208);
;// CONCATENATED MODULE: ./src/components/ConferenceOrderTickets/ConferenceOrderTickets.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var STATES;

(function (STATES) {
  STATES["\u010Cesk\xE1 Republika"] = "CZ";
  STATES["Slovensko"] = "SK";
})(STATES || (STATES = {}));

var ConferenceTicketOrderTemplate = function ConferenceTicketOrderTemplate(_ref) {
  var _conf$conference2, _conf$conference3, _conf$conference3$tic, _businessCountryInput4;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      ticketsToMail = _useState[0],
      setTicketsToMail = _useState[1];

  var _useState2 = (0,react.useState)(0),
      totalPrice = _useState2[0],
      setTotalPrice = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isSent = _useState3[0],
      setIsSent = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isSending = _useState4[0],
      setIsSending = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      hasSentError = _useState5[0],
      setHasSentError = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      token = _useState6[0],
      setToken = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      missingData = _useState7[0],
      setMissingData = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      hasEmailError = _useState8[0],
      setHasEmailError = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      hasFirstNameError = _useState9[0],
      setHasFirstNameError = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      hasPhoneError = _useState10[0],
      setHasPhoneError = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      hasBusinessAddressError = _useState11[0],
      setHasBusinessAddressError = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      hasBusinessCityError = _useState12[0],
      setHasBusinessCityError = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      hasBusinessPostalCodeError = _useState13[0],
      setHasBusinessPostalCodeError = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      hasBillingDetails = _useState14[0],
      setHasBillingDetails = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      hasAgreement = _useState15[0],
      setHasAgreement = _useState15[1];

  var _useState16 = (0,react.useState)(false),
      hasBusinessNameError = _useState16[0],
      setHasBusinessNameError = _useState16[1];

  var _useState17 = (0,react.useState)(false),
      hasBusinessIdError = _useState17[0],
      setHasBusinessIdError = _useState17[1];

  var _useState18 = (0,react.useState)(false),
      hasBusinessVatIdError = _useState18[0],
      setHasBusinessVatIdError = _useState18[1];

  var _useState19 = (0,react.useState)(false),
      hasBusinessVatNoError = _useState19[0],
      setHasBusinessVatNoError = _useState19[1];

  var emailInputRef = (0,react.useRef)(null);
  var firstNameInputRef = (0,react.useRef)(null);
  var discountInputRef = (0,react.useRef)(null);
  var phoneInputRef = (0,react.useRef)(null);
  var businessNameInputRef = (0,react.useRef)(null);
  var businessIdInputRef = (0,react.useRef)(null);
  var businessVatIdInputRef = (0,react.useRef)(null);
  var businessVatNoInputRef = (0,react.useRef)(null);
  var businessCountryInputRef = (0,react.useRef)(null);
  var businessAddressInputRef = (0,react.useRef)(null);
  var businessPostalCodeInputRef = (0,react.useRef)(null);
  var businessCityInputRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var tmpPrice = 0;
    ticketsToMail.forEach(function (item) {
      return tmpPrice += item.totalPrice;
    });
    setTotalPrice(tmpPrice);
  }, [ticketsToMail]);

  var handleMissingData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setMissingData(true), setTimeout(function () {
                return setMissingData(false);
              }, 3000);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleMissingData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmitClick = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _firstNameInputRef$cu, _emailInputRef$curren, _emailInputRef$curren2, _phoneInputRef$curren, _phoneInputRef$curren2, _phoneInputRef$curren3, _phoneInputRef$curren4, _businessAddressInput, _businessCityInputRef, _businessPostalCodeIn, _businessPostalCodeIn2, _businessPostalCodeIn3, _businessPostalCodeIn4, _businessNameInputRef, _businessIdInputRef$c, _businessCountryInput, _businessCountryInput2, _businessCountryInput3, _conf$conference, _discountInputRef$cur, _emailInputRef$curren3, _businessAddressInput2, _firstNameInputRef$cu2, _businessCityInputRef2, _phoneInputRef$curren5, _businessPostalCodeIn5, _businessNameInputRef2, _businessIdInputRef$c2, _businessVatIdInputRe9, _businessVatIdInputRe10, _businessVatNoInputRe5, _businessVatNoInputRe6;

      var _businessVatIdInputRe, _businessVatIdInputRe2, _businessVatIdInputRe3, _businessVatIdInputRe4, _businessVatIdInputRe5, _businessVatIdInputRe6, _businessVatIdInputRe7, _businessVatIdInputRe8, _businessVatNoInputRe, _businessVatNoInputRe2, _businessVatNoInputRe3, _businessVatNoInputRe4, data;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setHasSentError(false);
              setHasEmailError(false);
              setHasFirstNameError(false);
              setHasPhoneError(false);
              setHasBusinessAddressError(false);
              setHasBusinessCityError(false);
              setHasBusinessPostalCodeError(false);
              setHasBusinessNameError(false);
              setHasBusinessIdError(false);
              setHasBusinessVatIdError(false);
              setHasBusinessVatNoError(false);
              setIsSent(false);

              if (!((firstNameInputRef === null || firstNameInputRef === void 0 ? void 0 : (_firstNameInputRef$cu = firstNameInputRef.current) === null || _firstNameInputRef$cu === void 0 ? void 0 : _firstNameInputRef$cu.value) === '')) {
                _context2.next = 16;
                break;
              }

              setHasFirstNameError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 16:
              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context2.next = 20;
                break;
              }

              setHasEmailError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 20:
              if (!((phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) === '')) {
                _context2.next = 26;
                break;
              }

              setHasPhoneError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 26:
              if (!(phoneInputRef !== null && phoneInputRef !== void 0 && (_phoneInputRef$curren2 = phoneInputRef.current) !== null && _phoneInputRef$curren2 !== void 0 && _phoneInputRef$curren2.value && !(phoneInputRef !== null && phoneInputRef !== void 0 && (_phoneInputRef$curren3 = phoneInputRef.current) !== null && _phoneInputRef$curren3 !== void 0 && (_phoneInputRef$curren4 = _phoneInputRef$curren3.value) !== null && _phoneInputRef$curren4 !== void 0 && _phoneInputRef$curren4.match(/^[+]?[/0-9. -]{9,}$/)))) {
                _context2.next = 30;
                break;
              }

              setHasPhoneError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 30:
              if (!((businessAddressInputRef === null || businessAddressInputRef === void 0 ? void 0 : (_businessAddressInput = businessAddressInputRef.current) === null || _businessAddressInput === void 0 ? void 0 : _businessAddressInput.value) === '')) {
                _context2.next = 34;
                break;
              }

              setHasBusinessAddressError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 34:
              if (!((businessCityInputRef === null || businessCityInputRef === void 0 ? void 0 : (_businessCityInputRef = businessCityInputRef.current) === null || _businessCityInputRef === void 0 ? void 0 : _businessCityInputRef.value) === '')) {
                _context2.next = 38;
                break;
              }

              setHasBusinessCityError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 38:
              if (!((businessPostalCodeInputRef === null || businessPostalCodeInputRef === void 0 ? void 0 : (_businessPostalCodeIn = businessPostalCodeInputRef.current) === null || _businessPostalCodeIn === void 0 ? void 0 : _businessPostalCodeIn.value) === '')) {
                _context2.next = 44;
                break;
              }

              setHasBusinessPostalCodeError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 44:
              if (!(businessPostalCodeInputRef !== null && businessPostalCodeInputRef !== void 0 && (_businessPostalCodeIn2 = businessPostalCodeInputRef.current) !== null && _businessPostalCodeIn2 !== void 0 && _businessPostalCodeIn2.value && !(businessPostalCodeInputRef !== null && businessPostalCodeInputRef !== void 0 && (_businessPostalCodeIn3 = businessPostalCodeInputRef.current) !== null && _businessPostalCodeIn3 !== void 0 && (_businessPostalCodeIn4 = _businessPostalCodeIn3.value) !== null && _businessPostalCodeIn4 !== void 0 && _businessPostalCodeIn4.match(/^[0-9]{5}$/)))) {
                _context2.next = 48;
                break;
              }

              setHasBusinessPostalCodeError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 48:
              if (!(hasBillingDetails && (businessNameInputRef === null || businessNameInputRef === void 0 ? void 0 : (_businessNameInputRef = businessNameInputRef.current) === null || _businessNameInputRef === void 0 ? void 0 : _businessNameInputRef.value) === '')) {
                _context2.next = 52;
                break;
              }

              setHasBusinessNameError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 52:
              if (!(hasBillingDetails && (businessIdInputRef === null || businessIdInputRef === void 0 ? void 0 : (_businessIdInputRef$c = businessIdInputRef.current) === null || _businessIdInputRef$c === void 0 ? void 0 : _businessIdInputRef$c.value) === '')) {
                _context2.next = 56;
                break;
              }

              setHasBusinessIdError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 56:
              if (!((businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput = businessCountryInputRef.current) === null || _businessCountryInput === void 0 ? void 0 : _businessCountryInput.value) === 'Slovensko')) {
                _context2.next = 69;
                break;
              }

              if (!(hasBillingDetails && (businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe = businessVatIdInputRef.current) === null || _businessVatIdInputRe === void 0 ? void 0 : _businessVatIdInputRe.value) === '')) {
                _context2.next = 63;
                break;
              }

              setHasBusinessVatIdError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 63:
              if (!(hasBillingDetails && businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe2 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe2 !== void 0 && _businessVatIdInputRe2.value && !(businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe3 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe3 !== void 0 && (_businessVatIdInputRe4 = _businessVatIdInputRe3.value) !== null && _businessVatIdInputRe4 !== void 0 && _businessVatIdInputRe4.match(/^[0-9]{10}$/)))) {
                _context2.next = 67;
                break;
              }

              setHasBusinessVatIdError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 67:
              _context2.next = 80;
              break;

            case 69:
              if (!((businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput2 = businessCountryInputRef.current) === null || _businessCountryInput2 === void 0 ? void 0 : _businessCountryInput2.value) === 'Česká Republika')) {
                _context2.next = 80;
                break;
              }

              if (!(hasBillingDetails && (businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe5 = businessVatIdInputRef.current) === null || _businessVatIdInputRe5 === void 0 ? void 0 : _businessVatIdInputRe5.value) === '')) {
                _context2.next = 76;
                break;
              }

              setHasBusinessVatIdError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 76:
              if (!(hasBillingDetails && businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe6 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe6 !== void 0 && _businessVatIdInputRe6.value && !(businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe7 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe7 !== void 0 && (_businessVatIdInputRe8 = _businessVatIdInputRe7.value) !== null && _businessVatIdInputRe8 !== void 0 && _businessVatIdInputRe8.match(/^[A-Z]{2}[0-9]{8,10}$/)))) {
                _context2.next = 80;
                break;
              }

              setHasBusinessVatIdError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 80:
              if (!((businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput3 = businessCountryInputRef.current) === null || _businessCountryInput3 === void 0 ? void 0 : _businessCountryInput3.value) === 'Slovensko')) {
                _context2.next = 93;
                break;
              }

              if (!(hasBillingDetails && (businessVatNoInputRef === null || businessVatNoInputRef === void 0 ? void 0 : (_businessVatNoInputRe = businessVatNoInputRef.current) === null || _businessVatNoInputRe === void 0 ? void 0 : _businessVatNoInputRe.value) === '')) {
                _context2.next = 87;
                break;
              }

              setHasBusinessVatNoError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 87:
              if (!(hasBillingDetails && businessVatNoInputRef !== null && businessVatNoInputRef !== void 0 && (_businessVatNoInputRe2 = businessVatNoInputRef.current) !== null && _businessVatNoInputRe2 !== void 0 && _businessVatNoInputRe2.value && !(businessVatNoInputRef !== null && businessVatNoInputRef !== void 0 && (_businessVatNoInputRe3 = businessVatNoInputRef.current) !== null && _businessVatNoInputRe3 !== void 0 && (_businessVatNoInputRe4 = _businessVatNoInputRe3.value) !== null && _businessVatNoInputRe4 !== void 0 && _businessVatNoInputRe4.match(/^[A-Z]{2}[0-9]{10}$/)))) {
                _context2.next = 91;
                break;
              }

              setHasBusinessVatNoError(true);
              handleMissingData();
              return _context2.abrupt("return");

            case 91:
              _context2.next = 94;
              break;

            case 93:
              setHasBusinessVatNoError(false);

            case 94:
              data = {
                name: conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.title,
                discount_code: discountInputRef === null || discountInputRef === void 0 ? void 0 : (_discountInputRef$cur = discountInputRef.current) === null || _discountInputRef$cur === void 0 ? void 0 : _discountInputRef$cur.value,
                person: {
                  email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value,
                  street: businessAddressInputRef === null || businessAddressInputRef === void 0 ? void 0 : (_businessAddressInput2 = businessAddressInputRef.current) === null || _businessAddressInput2 === void 0 ? void 0 : _businessAddressInput2.value,
                  name: firstNameInputRef === null || firstNameInputRef === void 0 ? void 0 : (_firstNameInputRef$cu2 = firstNameInputRef.current) === null || _firstNameInputRef$cu2 === void 0 ? void 0 : _firstNameInputRef$cu2.value,
                  city: businessCityInputRef === null || businessCityInputRef === void 0 ? void 0 : (_businessCityInputRef2 = businessCityInputRef.current) === null || _businessCityInputRef2 === void 0 ? void 0 : _businessCityInputRef2.value,
                  phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren5 = phoneInputRef.current) === null || _phoneInputRef$curren5 === void 0 ? void 0 : _phoneInputRef$curren5.value,
                  postal_code: businessPostalCodeInputRef === null || businessPostalCodeInputRef === void 0 ? void 0 : (_businessPostalCodeIn5 = businessPostalCodeInputRef.current) === null || _businessPostalCodeIn5 === void 0 ? void 0 : _businessPostalCodeIn5.value
                },
                company: _objectSpread(_objectSpread({
                  name: businessNameInputRef === null || businessNameInputRef === void 0 ? void 0 : (_businessNameInputRef2 = businessNameInputRef.current) === null || _businessNameInputRef2 === void 0 ? void 0 : _businessNameInputRef2.value,
                  business_id: businessIdInputRef === null || businessIdInputRef === void 0 ? void 0 : (_businessIdInputRef$c2 = businessIdInputRef.current) === null || _businessIdInputRef$c2 === void 0 ? void 0 : _businessIdInputRef$c2.value
                }, (businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe9 = businessVatIdInputRef.current) === null || _businessVatIdInputRe9 === void 0 ? void 0 : _businessVatIdInputRe9.value) !== '' && {
                  tax_id: businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe10 = businessVatIdInputRef.current) === null || _businessVatIdInputRe10 === void 0 ? void 0 : _businessVatIdInputRe10.value
                }), (businessVatNoInputRef === null || businessVatNoInputRef === void 0 ? void 0 : (_businessVatNoInputRe5 = businessVatNoInputRef.current) === null || _businessVatNoInputRe5 === void 0 ? void 0 : _businessVatNoInputRe5.value) !== '' && {
                  vat_no: businessVatNoInputRef === null || businessVatNoInputRef === void 0 ? void 0 : (_businessVatNoInputRe6 = businessVatNoInputRef.current) === null || _businessVatNoInputRe6 === void 0 ? void 0 : _businessVatNoInputRe6.value
                }),
                tickets: ticketsToMail,
                token: token
              };
              _context2.prev = 95;
              setIsSending(true);
              _context2.next = 99;
              return calendar_service/* calendarApi.sendOrderForm */.w.sendOrderForm(data);

            case 99:
              setIsSending(false);
              setIsSent(true);
              _context2.next = 107;
              break;

            case 103:
              _context2.prev = 103;
              _context2.t0 = _context2["catch"](95);
              setHasSentError(true);
              setIsSending(false);

            case 107:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[95, 103]]);
    }));

    return function handleSubmitClick() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSetCountTickets = function handleSetCountTickets(e) {
    if (ticketsToMail.findIndex(function (item) {
      return item.name === e.name;
    }) !== -1) {
      setTicketsToMail(ticketsToMail.map(function (previousHarmonogram) {
        return previousHarmonogram.name === e.name ? {
          count: e.count,
          name: e.name,
          totalPrice: e.totalPrice
        } : previousHarmonogram;
      }));
    } else {
      setTicketsToMail([].concat((0,toConsumableArray/* default */.Z)(ticketsToMail), [{
        count: e.count,
        name: e.name,
        totalPrice: e.totalPrice
      }]));
    }
  };

  var verifyRecaptchaCallback = (0,react.useCallback)(function (token) {
    setToken(token);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceOrderTickets_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.ORDERFORMTICKET),
    colors: colors,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceOrderTickets_elements_Title, {
      colors: colors,
      children: [t('conference.component.orderForm.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceOrderTickets_elements_TitleSymbol, {
        colors: colors
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderGeneralText, {
      children: "V p\u0159\xEDpad\u011B z\xE1jmu o \xFA\u010Dast, v\xE1s pros\xEDme, abyste vyplnili objedn\xE1vkov\xFD formul\xE1\u0159. Pro zasl\xE1n\xED faktury a vystaven\xED vstupenky v\xE1s n\xE1sledn\u011B kontaktuje referentka na\u0161eho vzd\u011Bl\xE1v\xE1n\xED."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderForm, {
      children: [(conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.tickets.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderFormTickets, {
          colors: colors,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderTitleText, {
            children: t('conference.general.selectTicket')
          }), conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : (_conf$conference3$tic = _conf$conference3.tickets) === null || _conf$conference3$tic === void 0 ? void 0 : _conf$conference3$tic.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceOrderTicket, {
              colors: colors,
              ticket: item,
              index: index,
              handleSetCountTickets: handleSetCountTickets
            }, "orderTicket".concat(index));
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Ticket, {
            footer: true,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TicketTitle, {
              footer: true
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketPrice, {
              footer: true,
              children: t('conference.general.total')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketButtons, {
              footer: true
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketPrice, {
              footer: true,
              children: [Math.round(totalPrice * 100) / 100, " ", t('conference.general.currencySign')]
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderTitleText, {
        children: t('conference.general.yourData')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderFormPerson, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceOrderTickets_elements_Col1, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasFirstNameError ? 'error' : '',
              ref: firstNameInputRef,
              placeholder: "".concat(t('conference.general.firstnameSurname'), "*")
            }), hasFirstNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              children: t('modal.register.firstName.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasEmailError ? 'error' : '',
              ref: emailInputRef,
              placeholder: "".concat(t('conference.general.email'), "*")
            }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              children: t('modal.register.mail.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasPhoneError ? 'error' : '',
              ref: phoneInputRef,
              placeholder: "".concat(t('conference.general.phone'), "*")
            }), hasPhoneError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              children: t('modal.register.phone.error')
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceOrderTickets_elements_Col2, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasBusinessAddressError ? 'error' : '',
              ref: businessAddressInputRef,
              placeholder: "".concat(t('conference.general.street'), "*")
            }), hasBusinessAddressError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              children: t('modal.register.address.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasBusinessCityError ? 'error' : '',
              ref: businessCityInputRef,
              placeholder: "".concat(t('conference.general.city'), "*")
            }), hasBusinessCityError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              children: t('modal.register.city.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasBusinessPostalCodeError ? 'error' : '',
              ref: businessPostalCodeInputRef,
              placeholder: "".concat(t('conference.general.postalCode'), "*")
            }), hasBusinessPostalCodeError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              children: t('modal.register.postalCode.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputSection, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Select, {
              bottom: 30,
              top: 10,
              ref: businessCountryInputRef,
              name: "businessCountry",
              children: Object.keys(STATES).map(function (value, key) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
                  value: value,
                  children: value
                }, key);
              })
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        name: "billing",
        checked: hasBillingDetails,
        onChange: function onChange() {
          return setHasBillingDetails(!hasBillingDetails);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckboxLabel, {
          colors: colors,
          children: ["Chcem zada\u0165 ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "firemn\xE9 \xFAdaje"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderFormCompany, {
        children: hasBillingDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceOrderTickets_elements_Col1, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessNameError ? 'error' : '',
                ref: businessNameInputRef,
                placeholder: "".concat(t('conference.general.companyName'), "*")
              }), hasBusinessNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                children: t('general.fillCorrectShape')
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessIdError ? 'error' : '',
                ref: businessIdInputRef,
                placeholder: "".concat(t('conference.general.IDnumber'), "*")
              }), hasBusinessIdError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                children: t('general.fillCorrectShape')
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceOrderTickets_elements_Col2, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessVatIdError ? 'error' : '',
                ref: businessVatIdInputRef,
                placeholder: "".concat(t('conference.general.taxId'), "*")
              }), hasBusinessVatIdError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                children: t('general.fillCorrectShape')
              })]
            }), (businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput4 = businessCountryInputRef.current) === null || _businessCountryInput4 === void 0 ? void 0 : _businessCountryInput4.value) === 'Slovensko' && /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessVatNoError ? 'error' : '',
                ref: businessVatNoInputRef,
                placeholder: "".concat(t('conference.general.taxIdVat'), "*")
              }), hasBusinessVatNoError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                children: t('general.fillCorrectShape')
              })]
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderFormDiscount, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DiscountLabel, {
          children: t('conference.general.iHaveDiscountCode')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DiscountCode, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: discountInputRef,
            placeholder: t('conference.general.enterDiscountCode')
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Agreements, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          name: "personally",
          checked: hasAgreement,
          onChange: function onChange() {
            return setHasAgreement(!hasAgreement);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckboxLabel, {
            colors: colors,
            children: ["Souhlas\xEDm so", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              onClick: function onClick() {
                return router.push({
                  pathname: constants/* ROUTES.GDPR */.Z6.GDPR
                });
              },
              children: "zpracov\xE1n\xEDm osobn\xEDch \xFAdaj\u016F"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
        onVerify: verifyRecaptchaCallback
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceOrderTickets_elements_Buttons, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonSendForm, {
        colors: colors,
        disabled: !hasAgreement || isSending || token,
        onClick: handleSubmitClick,
        children: isSending ? "".concat(t('conference.general.sending')) : "".concat(t('conference.general.sendOrder'))
      })
    }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.success */.d.success,
      message: t('conference.general.yourMessageWasSent')
    }), missingData && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.warning */.d.warning,
      message: t('conference.general.fillMissingData')
    }), hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderGeneralText, {
      children: "StudioW zpracov\xE1v\xE1 Va\u0161e osobn\xED \xFAdaje (jm\xE9no, p\u0159\xEDjmen\xED, adrena, email, telefon) pouze za \xFA\u010Delem vy\u0159\xEDzen\xED Va\u0161\xED objedn\xE1vky. Va\u0161e \xFAdaje budou zpracov\xE1ny v intern\xEDch a syst\xE9mech pou\u010Den\xFDmi pracovn\xEDky po dobu 10 let a nebudou d\xE1le poskytnuty \u017E\xE1dn\xFDm t\u0159et\xEDm osob\xE1m."
    })]
  });
};

/* harmony default export */ var ConferenceOrderTickets = (ConferenceTicketOrderTemplate);
;// CONCATENATED MODULE: ./src/components/ConferencePartners/ConferencePartners.elements.tsx



var ConferencePartners_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePartnerselements__Wrapper",
  componentId: "sc-p8j579-0"
})(["padding:", " 0 ", " 0;border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
var ConferencePartners_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePartnerselements__Title",
  componentId: "sc-p8j579-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferencePartners_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePartnerselements__TitleSymbol",
  componentId: "sc-p8j579-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var Partners = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePartnerselements__Partners",
  componentId: "sc-p8j579-3"
})(["display:flex;flex-direction:column;padding-top:", ";@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var ConferencePartners_elements_Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePartnerselements__Label",
  componentId: "sc-p8j579-4"
})(["font-weight:", ";min-width:", ";padding-bottom:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(200), (0,polished_esm/* rem */.hO)(25));
var Images = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePartnerselements__Images",
  componentId: "sc-p8j579-5"
})([""]);
var ConferencePartners_elements_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferencePartnerselements__Image",
  componentId: "sc-p8j579-6"
})(["width:", ";padding:0 ", " ", " 0;"], (0,polished_esm/* rem */.hO)(150), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var ConferencePartners_elements_Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferencePartnerselements__Link",
  componentId: "sc-p8j579-7"
})([""]);
;// CONCATENATED MODULE: ./src/components/ConferencePartners/ConferencePartners.tsx









var ConferencePartnersTemplate = function ConferencePartnersTemplate(_ref) {
  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  console.log('AA', conf === null || conf === void 0 ? void 0 : conf.partners);
  var organizers = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(0)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  var coorganizers = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(1)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  var mainpartner = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(2)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  var partners = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(3)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  var expertpartner = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(4)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  var promopartner = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(5)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  var mediapartner = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(6)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  var generalpartner = conf === null || conf === void 0 ? void 0 : conf.partners.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.conferencePartnerType.includes(7)) && !(item !== null && item !== void 0 && item.isPatron);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.PARTNERS),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Title, {
      colors: colors,
      children: [t('conference.component.partners.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_TitleSymbol, {
        colors: colors
      })]
    }), organizers.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [organizers.length === 1 ? t('conference.general.organizer') : t('conference.general.organizers'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: organizers.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "porganizers".concat(index));
          })
        })]
      })
    }), coorganizers.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [t('conference.general.coOrganizers'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: coorganizers.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "pcoorganizers".concat(index));
          })
        })]
      })
    }), generalpartner.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [t('conference.general.generalPartner'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: generalpartner.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "pgeneralpartner".concat(index));
          })
        })]
      })
    }), mainpartner.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [t('conference.general.mainPartner'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: mainpartner.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "pmainpartner".concat(index));
          })
        })]
      })
    }), partners.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [partners.length === 1 ? t('conference.general.partner') : t('conference.general.partners'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: partners.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "ppartners".concat(index));
          })
        })]
      })
    }), expertpartner.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [t('conference.general.professionalPartner'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: expertpartner.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "pexpertpartner".concat(index));
          })
        })]
      })
    }), promopartner.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [t('conference.general.promoPartners'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: promopartner.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "ppromopartner".concat(index));
          })
        })]
      })
    }), mediapartner.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePartners_elements_Label, {
          children: [t('conference.general.mediaPartners'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Images, {
          children: mediapartner.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Link, {
              href: item.url,
              target: "_blank",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners_elements_Image, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/thumbnail/partner/").concat(item.photo, "?size=200"),
                alt: item.photo,
                title: item.name
              })
            }, "pmediapartner".concat(index));
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var ConferencePartners = (ConferencePartnersTemplate);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/style.css
var style = __webpack_require__(23955);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/dist/index.es.js
var index_es = __webpack_require__(92879);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/components/ConferencePhotoGallery/ConferencePhotoGallery.elements.tsx



var ConferencePhotoGallery_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__Wrapper",
  componentId: "sc-nn8p67-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15));
var ConferencePhotoGallery_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePhotoGalleryelements__Title",
  componentId: "sc-nn8p67-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferencePhotoGallery_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePhotoGalleryelements__TitleSymbol",
  componentId: "sc-nn8p67-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferencePhotoGallery_elements_Tabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__Tabs",
  componentId: "sc-nn8p67-3"
})(["display:flex;border-bottom:1px solid ", ";margin-top:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var ConferencePhotoGallery_elements_Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__Tab",
  componentId: "sc-nn8p67-4"
})(["margin-right:", ";color:", ";cursor:pointer;&.active{font-weight:", ";border-bottom:2px solid ", ";padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(30), function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors4;

  return (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorLink;
}, (0,polished_esm/* rem */.hO)(10));
var Conference = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__Conference",
  componentId: "sc-nn8p67-5"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(30));
var ConferenceLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferencePhotoGalleryelements__ConferenceLink",
  componentId: "sc-nn8p67-6"
})(["font-weight:", ";color:", ";cursor:pointer;text-decoration:none;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors5;

  return (_props$colors5 = props.colors) === null || _props$colors5 === void 0 ? void 0 : _props$colors5.colorLink;
});
var Record = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__Record",
  componentId: "sc-nn8p67-7"
})([""]);
var RecordLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePhotoGalleryelements__RecordLabel",
  componentId: "sc-nn8p67-8"
})(["font-weight:", ";display:block;padding-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10));
var Source = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferencePhotoGalleryelements__Source",
  componentId: "sc-nn8p67-9"
})(["color:", ";font-size:", ";padding:", " 0;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(10));
var Gallery = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__Gallery",
  componentId: "sc-nn8p67-10"
})([""]);
var GalleryLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePhotoGalleryelements__GalleryLabel",
  componentId: "sc-nn8p67-11"
})(["font-weight:", ";display:block;padding-bottom:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(5));
var GalleryDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePhotoGalleryelements__GalleryDescription",
  componentId: "sc-nn8p67-12"
})([""]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__ImageWrapper",
  componentId: "sc-nn8p67-13"
})(["padding:", " 0;display:flex !important;flex-flow:row;align-items:center;justify-content:center;height:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(200));
var GalleryImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferencePhotoGalleryelements__GalleryImage",
  componentId: "sc-nn8p67-14"
})(["width:auto;height:100%;cursor:pointer;"]);
var CarouselWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__CarouselWrapper",
  componentId: "sc-nn8p67-15"
})(["padding:", " 0;@media (min-width:", "px){max-width:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(805));
var ConferencePhotoGallery_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__Content",
  componentId: "sc-nn8p67-16"
})([""]);
var RecordContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__RecordContent",
  componentId: "sc-nn8p67-17"
})(["display:flex;flex-direction:column;width:100%;height:450px;padding:", " ", ";align-items:center;@media (max-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm);
var ConferencePhotoGallery_elements_EmbedContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryelements__EmbedContent",
  componentId: "sc-nn8p67-18"
})(["position:relative;display:block;width:100%;height:100%;padding:0;overflow:hidden;"]);
var ConferencePhotoGallery_elements_Embed = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "ConferencePhotoGalleryelements__Embed",
  componentId: "sc-nn8p67-19"
})(["position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0;"]);
;// CONCATENATED MODULE: ./src/components/ConferencePhotoGallery/ConferencePhotoGalleryContentImage.tsx



function ConferencePhotoGalleryContentImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ConferencePhotoGalleryContentImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ConferencePhotoGalleryContentImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ConferencePhotoGalleryContentImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var ConferencePhotoGalleryContentImageTemplate = function ConferencePhotoGalleryContentImageTemplate(_ref) {
  var gallery = _ref.gallery;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)([]),
      images = _useState[0],
      setImages = _useState[1];

  var _useState2 = (0,react.useState)(1),
      countSlides = _useState2[0],
      setCountSlides = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      imgFocus = _useState3[0],
      setImgFocus = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      imgIndex = _useState4[0],
      setImgIndex = _useState4[1];

  var loadImagesByGalleryKey = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(key) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return calendar_service/* calendarApi.getGalleryImages */.w.getGalleryImages(key);

            case 2:
              response = _context.sent;
              setImages(response.data.results);

              if (response.data.results.length === 1) {
                setCountSlides(1);
              } else if (response.data.results.length === 2) {
                setCountSlides(2);
              } else if (response.data.results.length > 2) {
                setCountSlides(3);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadImagesByGalleryKey(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (gallery) {
      loadImagesByGalleryKey(gallery);
    }
  }, [gallery]);
  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: countSlides,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    responsive: [{
      breakpoint: theme/* breakpoints.sm */.A.sm,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    }, {
      breakpoint: theme/* breakpoints.md */.A.md,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    }]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [images.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Gallery, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, ConferencePhotoGalleryContentImage_objectSpread(ConferencePhotoGalleryContentImage_objectSpread({}, settings), {}, {
          children: images.map(function (img, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(GalleryImage, {
                src: "".concat((0,constants/* getApiURL */.tU)(), "/media/image/").concat(img._key, "/file"),
                onClick: function onClick() {
                  setImgIndex(index);
                  setImgFocus(true);
                }
              })
            }, "image".concat(gallery).concat(index));
          })
        }))
      })
    }), imgFocus && /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
      mainSrc: "".concat((0,constants/* getApiURL */.tU)(), "/media/image/").concat(images[imgIndex]._key, "/file"),
      nextSrc: images[(imgIndex + 1) % images.length],
      prevSrc: images[(imgIndex + images.length - 1) % images.length],
      onCloseRequest: function onCloseRequest() {
        return setImgFocus(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return setImgIndex((imgIndex + images.length - 1) % images.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setImgIndex((imgIndex + 1) % images.length);
      }
    })]
  });
};

/* harmony default export */ var ConferencePhotoGalleryContentImage = (ConferencePhotoGalleryContentImageTemplate);
;// CONCATENATED MODULE: ./src/components/ConferencePhotoGallery/ConferencePhotoGalleryTab.tsx








var ConferencePhotoGalleryTabTemplate = function ConferencePhotoGalleryTabTemplate(_ref) {
  var _archive$conference3, _conference$conferenc;

  var colors = _ref.colors,
      archive = _ref.archive,
      activeSection = _ref.activeSection,
      setActiveSection = _ref.setActiveSection,
      index = _ref.index;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(),
      conference = _useState[0],
      setConference = _useState[1];

  var loadConferenceByKey = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(key) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return calendar_service/* calendarApi.getConferenceKey */.w.getConferenceKey(key);

            case 2:
              response = _context.sent;
              setConference(response.data);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadConferenceByKey(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var _archive$conference;

    if (archive !== null && archive !== void 0 && (_archive$conference = archive.conference) !== null && _archive$conference !== void 0 && _archive$conference._key) {
      var _archive$conference2;

      loadConferenceByKey(archive === null || archive === void 0 ? void 0 : (_archive$conference2 = archive.conference) === null || _archive$conference2 === void 0 ? void 0 : _archive$conference2._key);
    }
  }, [archive === null || archive === void 0 ? void 0 : (_archive$conference3 = archive.conference) === null || _archive$conference3 === void 0 ? void 0 : _archive$conference3._key]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGallery_elements_Tab, {
    colors: colors,
    className: activeSection === "previousTab".concat(index) ? 'active' : '',
    onClick: function onClick() {
      return setActiveSection("previousTab".concat(index));
    },
    children: conference === null || conference === void 0 ? void 0 : (_conference$conferenc = conference.conference) === null || _conference$conferenc === void 0 ? void 0 : _conference$conferenc.title
  });
};

/* harmony default export */ var ConferencePhotoGalleryTab = (ConferencePhotoGalleryTabTemplate);
;// CONCATENATED MODULE: ./src/components/ConferencePhotoGalleryStatic/ConferencePhotoGalleryStatic.elements.tsx


var ConferencePhotoGalleryStatic_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryStaticelements__Wrapper",
  componentId: "sc-sug91b-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15));
var ConferencePhotoGalleryStatic_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePhotoGalleryStaticelements__Title",
  componentId: "sc-sug91b-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferencePhotoGalleryStatic_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePhotoGalleryStaticelements__TitleSymbol",
  componentId: "sc-sug91b-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferencePhotoGalleryStatic_elements_Gallery = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryStaticelements__Gallery",
  componentId: "sc-sug91b-3"
})(["display:flex;flex-wrap:wrap;gap:", ";"], (0,polished_esm/* rem */.hO)(30));
var ConferencePhotoGalleryStatic_elements_ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePhotoGalleryStaticelements__ImageWrapper",
  componentId: "sc-sug91b-4"
})(["padding:", " 0;display:flex !important;flex-flow:row;align-items:center;justify-content:center;height:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(300));
var ConferencePhotoGalleryStatic_elements_GalleryImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferencePhotoGalleryStaticelements__GalleryImage",
  componentId: "sc-sug91b-5"
})(["width:auto;height:100%;"]);
;// CONCATENATED MODULE: ./src/components/ConferencePhotoGalleryStatic/ConferencePhotoGalleryStatic.tsx








var ConferencePhotoGalleryTemplate = function ConferencePhotoGalleryTemplate(_ref) {
  var _conf$conference3;

  var conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)([]),
      images = _useState[0],
      setImages = _useState[1];

  (0,react.useEffect)(function () {
    var _conf$conference;

    if (conf !== null && conf !== void 0 && (_conf$conference = conf.conference) !== null && _conf$conference !== void 0 && _conf$conference.static_gallery) {
      var _conf$conference2;

      setImages(conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.static_gallery);
    }
  }, [conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : _conf$conference3.static_gallery]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: (images === null || images === void 0 ? void 0 : images.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGalleryStatic_elements_Gallery, {
      children: images === null || images === void 0 ? void 0 : images.map(function (photo, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGalleryStatic_elements_ImageWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGalleryStatic_elements_GalleryImage, {
            src: "".concat((0,constants/* getApiURL */.tU)(), "/media/conference/static-gallery/").concat(photo)
          }, index)
        }, "image".concat(photo).concat(index));
      })
    })
  });
};

/* harmony default export */ var ConferencePhotoGalleryStatic = (ConferencePhotoGalleryTemplate);
;// CONCATENATED MODULE: ./src/components/ConferencePhotoGallery/ConferencePhotoGallery.tsx












var ConferencePhotoGallery_ConferencePhotoGalleryTemplate = function ConferencePhotoGalleryTemplate(_ref) {
  var _conf$conference, _conf$conference$stat, _conf$conference2, _conf$conference3, _conf$conference4;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)('previousTab0'),
      activeSection = _useState[0],
      setActiveSection = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePhotoGallery_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.PHOTOGALLERY),
    colors: colors,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePhotoGallery_elements_Title, {
      colors: colors,
      children: [t('conference.component.photogallery.title'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGallery_elements_TitleSymbol, {
        colors: colors
      })]
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : (_conf$conference$stat = _conf$conference.static_gallery) === null || _conf$conference$stat === void 0 ? void 0 : _conf$conference$stat.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGalleryStatic, {
      conf: conf
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: (conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.galleries.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGallery_elements_Tabs, {
          children: conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : _conf$conference3.galleries.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGalleryTab, {
              colors: colors,
              gallery: item,
              activeSection: activeSection,
              setActiveSection: setActiveSection,
              index: index
            }, "previousTab".concat(index));
          })
        }), conf === null || conf === void 0 ? void 0 : (_conf$conference4 = conf.conference) === null || _conf$conference4 === void 0 ? void 0 : _conf$conference4.galleries.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGalleryContentImage, {
            colors: colors,
            gallery: item._key,
            activeSection: activeSection,
            setActiveSection: setActiveSection,
            index: index
          }, "previousContent".concat(index));
        })]
      })
    })]
  });
};

/* harmony default export */ var ConferencePhotoGallery = (ConferencePhotoGallery_ConferencePhotoGalleryTemplate);
;// CONCATENATED MODULE: ./src/components/ConferencePrevious/ConferencePrevious.elements.tsx



var ConferencePrevious_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Wrapper",
  componentId: "sc-1lj6j4j-0"
})(["padding:", " ", " ", " ", ";background:", ";.slick-dots{bottom:-30px;li{width:20px;height:20px;button{&:before{font-size:10px;opacity:1;color:", ";}}&.slick-active{button{&:before{color:", ";}}}}}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorLightest;
}, function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorNonLecture;
}, function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
});
var ConferencePrevious_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePreviouselements__Title",
  componentId: "sc-1lj6j4j-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors4;

  return (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorTitle;
});
var ConferencePrevious_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePreviouselements__TitleSymbol",
  componentId: "sc-1lj6j4j-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors5;

  return (_props$colors5 = props.colors) === null || _props$colors5 === void 0 ? void 0 : _props$colors5.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferencePrevious_elements_Tabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Tabs",
  componentId: "sc-1lj6j4j-3"
})(["display:flex;border-bottom:1px solid ", ";margin-top:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var ConferencePrevious_elements_Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Tab",
  componentId: "sc-1lj6j4j-4"
})(["margin-right:", ";color:", ";cursor:pointer;&.active{font-weight:", ";border-bottom:2px solid ", ";padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(30), function (props) {
  var _props$colors6;

  return (_props$colors6 = props.colors) === null || _props$colors6 === void 0 ? void 0 : _props$colors6.colorLink;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors7;

  return (_props$colors7 = props.colors) === null || _props$colors7 === void 0 ? void 0 : _props$colors7.colorLink;
}, (0,polished_esm/* rem */.hO)(10));
var ConferencePrevious_elements_Conference = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Conference",
  componentId: "sc-1lj6j4j-5"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(30));
var ConferencePrevious_elements_ConferenceLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferencePreviouselements__ConferenceLink",
  componentId: "sc-1lj6j4j-6"
})(["font-weight:", ";color:", ";cursor:pointer;text-decoration:none;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors8;

  return (_props$colors8 = props.colors) === null || _props$colors8 === void 0 ? void 0 : _props$colors8.colorLink;
});
var ConferencePrevious_elements_Record = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Record",
  componentId: "sc-1lj6j4j-7"
})([""]);
var ConferencePrevious_elements_RecordLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePreviouselements__RecordLabel",
  componentId: "sc-1lj6j4j-8"
})(["font-weight:", ";display:block;padding-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10));
var ConferencePrevious_elements_Source = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferencePreviouselements__Source",
  componentId: "sc-1lj6j4j-9"
})(["color:", ";font-size:", ";padding:", " 0;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(10));
var ConferencePrevious_elements_Gallery = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Gallery",
  componentId: "sc-1lj6j4j-10"
})([""]);
var ConferencePrevious_elements_GalleryLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePreviouselements__GalleryLabel",
  componentId: "sc-1lj6j4j-11"
})(["font-weight:", ";display:block;padding-bottom:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(5));
var ConferencePrevious_elements_GalleryDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePreviouselements__GalleryDescription",
  componentId: "sc-1lj6j4j-12"
})([""]);
var ConferencePrevious_elements_GalleryImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferencePreviouselements__GalleryImage",
  componentId: "sc-1lj6j4j-13"
})(["width:95% !important;cursor:pointer;"]);
var ConferencePrevious_elements_CarouselWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__CarouselWrapper",
  componentId: "sc-1lj6j4j-14"
})(["padding:", " 0;@media (min-width:", "px){max-width:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(805));
var ConferencePrevious_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Content",
  componentId: "sc-1lj6j4j-15"
})([""]);
var ConferencePrevious_elements_RecordContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__RecordContent",
  componentId: "sc-1lj6j4j-16"
})(["display:flex;flex-direction:column;width:100%;height:450px;padding:", " ", ";align-items:center;@media (max-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm);
var ConferencePrevious_elements_EmbedContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__EmbedContent",
  componentId: "sc-1lj6j4j-17"
})(["position:relative;display:block;width:100%;height:100%;padding:0;overflow:hidden;"]);
var ConferencePrevious_elements_Embed = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "ConferencePreviouselements__Embed",
  componentId: "sc-1lj6j4j-18"
})(["position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0;"]);
var Links = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePreviouselements__Links",
  componentId: "sc-1lj6j4j-19"
})(["display:flex;flex-direction:column;margin-top:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(15));
var ConferencePrevious_elements_Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferencePreviouselements__Link",
  componentId: "sc-1lj6j4j-20"
})(["color:", ";padding-top:", ";"], function (props) {
  var _props$colors9;

  return (_props$colors9 = props.colors) === null || _props$colors9 === void 0 ? void 0 : _props$colors9.colorLine;
}, (0,polished_esm/* rem */.hO)(10));
;// CONCATENATED MODULE: ./src/components/ConferencePrevious/ConferencePrevious.tsx








var ConferencePreviousTemplate = function ConferencePreviousTemplate(_ref) {
  var _conf$conference, _conf$conference2;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePrevious_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.ARCHIVE),
    colors: colors,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePrevious_elements_Title, {
      colors: colors,
      children: [t('conference.component.previous.title'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrevious_elements_TitleSymbol, {
        colors: colors
      })]
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.archives.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Links, {
      children: conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.archives.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrevious_elements_Link, {
          href: item.conference.url,
          target: "_blank",
          colors: colors,
          children: item.conference.name
        }, "".concat(item.conference.name).concat(index));
      })
    })]
  });
};

/* harmony default export */ var ConferencePrevious = (ConferencePreviousTemplate);
;// CONCATENATED MODULE: ./src/components/ConferencePrivacy/ConferencePrivacy.elements.tsx


var ConferencePrivacy_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferencePrivacyelements__Wrapper",
  componentId: "sc-11bmt4x-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15));
var ConferencePrivacy_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePrivacyelements__Title",
  componentId: "sc-11bmt4x-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferencePrivacy_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferencePrivacyelements__TitleSymbol",
  componentId: "sc-11bmt4x-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferencePrivacy_elements_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferencePrivacyelements__Description",
  componentId: "sc-11bmt4x-3"
})(["margin-bottom:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20));
var ConferencePrivacy_elements_Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferencePrivacyelements__Link",
  componentId: "sc-11bmt4x-4"
})(["color:", ";font-weight:600;"], function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
});
;// CONCATENATED MODULE: ./src/components/ConferencePrivacy/ConferencePrivacy.tsx







var ConferencePrivacyTemplate = function ConferencePrivacyTemplate(_ref) {
  var colors = _ref.colors;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePrivacy_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.NOTICERECORDING),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePrivacy_elements_Title, {
      colors: colors,
      children: [t('conference.component.digitalRecordInfo.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrivacy_elements_TitleSymbol, {
        colors: colors
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrivacy_elements_Description, {
      children: "V r\xE1mci opr\xE1vnen\xFDch z\xE1ujmov prev\xE1dzkovate\u013Ea, ktor\xFDm je spolo\u010Dnos\u0165 Poradca podnikate\u013Ea, spol. s r. o., Martina R\xE1zusa 23A, 010 01 \u017Dilina, I\u010CO: 31 592 503, S-EPI, s. r. o., Martina R\xE1zusa 23A/8336, 010 01 \u017Dilina, I\u010CO: 36 014 991, EUROK\xD3DEX, s. r. o., Martina R\xE1zusa 23A, 010 01 \u017Dilina, I\u010CO: 44 871 3842, bude o \xFA\u010Dastn\xEDkoch a zauj\xEDmav\xFDch momentoch podujatia v zmysle \u010Dl. 6 ods. 1 p\xEDsm. f) v\u0161eobecn\xE9ho nariadenia o ochrane \xFAdajov vyhotoven\xE1 fotodokument\xE1cia a videoz\xE1znamy, ktor\xE9 m\xF4\u017Eu by\u0165 n\xE1sledne pou\u017Eit\xE9 na propag\xE1ciu aktiv\xEDt prev\xE1dzkovate\u013Ea. Napriek tomu, \u017Ee vyhotovenie uvedenej dokument\xE1cie nie je podmienen\xE9 s\xFAhlasom dotknutej osoby, re\u0161pektujeme v\xE1\u0161 pr\xEDpadn\xFD nez\xE1ujem o sn\xEDmanie va\u0161ej osoby."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferencePrivacy_elements_Description, {
      children: ["V uvedenom pr\xEDpade informujte pri registr\xE1cii niektor\xFA z na\u0161ich referentiek alebo n\xE1m svoj nes\xFAhlas za\u0161lite na emailov\xFA adresu", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrivacy_elements_Link, {
        colors: colors,
        href: "mailto:sinska@pp.sk",
        children: "sinska@pp.sk"
      }), ' ', ". Viac inform\xE1ci\xED o z\xE1sad\xE1ch ochrany osobn\xFDch \xFAdajov n\xE1jdete v \u010Dasti", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrivacy_elements_Link, {
        colors: colors,
        href: "https://www.zakon.sk/podmienky-spracovania-ou.xhtml",
        target: "_blank",
        children: "Podmienky spracovania osobn\xFDch \xFAdajov"
      }), "."]
    })]
  });
};

/* harmony default export */ var ConferencePrivacy = (ConferencePrivacyTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceProgram/ConferenceProgram.elements.tsx



var ConferenceProgram_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Wrapper",
  componentId: "sc-alee2k-0"
})(["padding:", " ", " ", " ", ";background:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorLightest;
});
var WrapperLecturer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__WrapperLecturer",
  componentId: "sc-alee2k-1"
})([""]);
var ConferenceProgram_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__Title",
  componentId: "sc-alee2k-2"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  return props.colors.colorTitle;
});
var ConferenceProgram_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__TitleSymbol",
  componentId: "sc-alee2k-3"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  return props.colors.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferenceProgram_elements_Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Description",
  componentId: "sc-alee2k-4"
})(["padding-bottom:", ";display:flex;position:relative;"], (0,polished_esm/* rem */.hO)(25));
var ConferenceProgram_elements_Tabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Tabs",
  componentId: "sc-alee2k-5"
})(["display:flex;border-bottom:1px solid ", ";margin-top:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var ConferenceProgram_elements_Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Tab",
  componentId: "sc-alee2k-6"
})(["margin-right:", ";color:", ";cursor:pointer;&.active{font-weight:", ";border-bottom:2px solid ", ";padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(30), function (props) {
  return props.colors.colorLink;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  return props.colors.colorLink;
}, (0,polished_esm/* rem */.hO)(10));
var Moderator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Moderator",
  componentId: "sc-alee2k-7"
})(["display:flex;flex-direction:column;justify-content:flex-start;padding:", " 0;border-bottom:1px solid ", ";@media (min-width:", "px){flex-direction:row;align-items:center;}"], (0,polished_esm/* rem */.hO)(40), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondaryGrey;
}, theme/* breakpoints.sm */.A.sm);
var ModeratorDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__ModeratorDesc",
  componentId: "sc-alee2k-8"
})(["display:block;"]);
var ModeratorImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferenceProgramelements__ModeratorImage",
  componentId: "sc-alee2k-9"
})(["width:", ";height:", ";border-radius:50%;margin-right:", ";"], (0,polished_esm/* rem */.hO)(110), (0,polished_esm/* rem */.hO)(110), (0,polished_esm/* rem */.hO)(40));
var ModeratorName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__ModeratorName",
  componentId: "sc-alee2k-10"
})(["font-weight:", ";padding:", " ", " ", " 0;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5));
var ModeratorLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__ModeratorLabel",
  componentId: "sc-alee2k-11"
})(["margin-bottom:", ";color:", ";"], (0,polished_esm/* rem */.hO)(2), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
});
var ConferenceProgram_elements_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Row",
  componentId: "sc-alee2k-12"
})(["display:flex;flex-direction:column;padding:", " 0;", ";@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(25), function (prop) {
  return prop.withoutBorder ? '' : "border-bottom: 1px solid ".concat(prop.theme.colors.secondaryGrey);
}, theme/* breakpoints.sm */.A.sm);
var RowTime = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__RowTime",
  componentId: "sc-alee2k-13"
})(["width:25%;margin-bottom:", ";@media (max-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm);
var Time = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__Time",
  componentId: "sc-alee2k-14"
})([""]);
var RowContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__RowContent",
  componentId: "sc-alee2k-15"
})(["width:75%;@media (max-width:", "px){width:100%;}"], theme/* breakpoints.sm */.A.sm);
var RowSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__RowSection",
  componentId: "sc-alee2k-16"
})(["display:flex;flex-direction:column;"]);
var RowSectionTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__RowSectionTitle",
  componentId: "sc-alee2k-17"
})(["font-weight:", ";font-size:", ";padding-bottom:", ";color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeights.textBold;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(10), function (prop) {
  var _prop$colors;

  return (_prop$colors = prop.colors) === null || _prop$colors === void 0 ? void 0 : _prop$colors.colorNonLecture;
});
var RowSectionTitleLecture = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__RowSectionTitleLecture",
  componentId: "sc-alee2k-18"
})(["font-weight:", ";font-size:", ";padding-bottom:", ";color:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeights.textBold;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(10), function (prop) {
  return prop.colors.colorLink;
});
var RowSectionLecturer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__RowSectionLecturer",
  componentId: "sc-alee2k-19"
})(["margin-top:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(22));
var RowSectionLecturerName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__RowSectionLecturerName",
  componentId: "sc-alee2k-20"
})(["font-weight:", ";padding:0 ", " ", " 0;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10));
var RowSectionLecturerPosition = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__RowSectionLecturerPosition",
  componentId: "sc-alee2k-21"
})(["color:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.grey;
});
var RowSectionAbstract = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__RowSectionAbstract",
  componentId: "sc-alee2k-22"
})(["padding-bottom:", ";color:", ";display:flex;align-items:center;"], (0,polished_esm/* rem */.hO)(10), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.grey;
});
var RowSectionAbstractLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__RowSectionAbstractLink",
  componentId: "sc-alee2k-23"
})(["background:", ";color:", ";padding:0 ", ";cursor:pointer;margin-left:", ";"], function (props) {
  var _props$colors2;

  return props === null || props === void 0 ? void 0 : (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLight;
}, function (props) {
  var _props$colors3;

  return props === null || props === void 0 ? void 0 : (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
}, (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(10));
var Block = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Block",
  componentId: "sc-alee2k-24"
})(["background:", ";padding:", " ", ";font-weight:", ";margin:", " 0;"], function (props) {
  return props.colors.colorLink;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(15), function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10));
var BlockNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__BlockNumber",
  componentId: "sc-alee2k-25"
})(["color:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.white;
});
var BlockName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__BlockName",
  componentId: "sc-alee2k-26"
})(["color:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.white;
});
var LegislativeLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceProgramelements__LegislativeLabel",
  componentId: "sc-alee2k-27"
})(["color:", ";display:block;margin-top:", ";font-size:", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(25), function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSizes.textBase;
});
var ConferenceProgram_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Content",
  componentId: "sc-alee2k-28"
})(["margin:0 ", ";"], (0,polished_esm/* rem */.hO)(10));
var ContentAbstract = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__ContentAbstract",
  componentId: "sc-alee2k-29"
})(["padding:0 ", ";border-left:2px solid ", ";p{margin:0;line-height:", ";font-weight:300;padding:", " 0;}"], (0,polished_esm/* rem */.hO)(10), function (props) {
  var _props$colors4;

  return props === null || props === void 0 ? void 0 : (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorLine;
}, (0,polished_esm/* rem */.hO)(18), (0,polished_esm/* rem */.hO)(10));
var BlockPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__BlockPanel",
  componentId: "sc-alee2k-30"
})(["font-weight:", ";margin-bottom:", ";"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(30));
var BlockPanelLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__BlockPanelLabel",
  componentId: "sc-alee2k-31"
})(["color:", ";background:", ";padding:", " ", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.white;
}, function (props) {
  return props.colors.colorLink;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(15));
var Empty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceProgramelements__Empty",
  componentId: "sc-alee2k-32"
})([""]);
;// CONCATENATED MODULE: ./src/components/ConferenceProgram/ConferenceProgramLecturer.tsx









var ConferenceProgramLecturerTemplate = function ConferenceProgramLecturerTemplate(_ref) {
  var _person$titles, _person$titles2, _person$titles3, _person$titles4, _person$position, _person$company;

  var colors = _ref.colors,
      personKey = _ref.personKey,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)({}),
      person = _useState[0],
      setPerson = _useState[1];

  var loadPersonByKey = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(personKey) {
      var lect;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              lect = conf === null || conf === void 0 ? void 0 : conf.lectors.filter(function (item) {
                return (item === null || item === void 0 ? void 0 : item._from.split('/')[1]) === personKey;
              });
              setPerson(lect[0]);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadPersonByKey(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (personKey) {
      loadPersonByKey(personKey);
    }
  }, [personKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WrapperLecturer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(RowSectionLecturerName, {
      children: [(person === null || person === void 0 ? void 0 : (_person$titles = person.titles) === null || _person$titles === void 0 ? void 0 : _person$titles.before_name) && "".concat(person === null || person === void 0 ? void 0 : (_person$titles2 = person.titles) === null || _person$titles2 === void 0 ? void 0 : _person$titles2.before_name, " "), person === null || person === void 0 ? void 0 : person.name, " ", person === null || person === void 0 ? void 0 : person.surname, (person === null || person === void 0 ? void 0 : (_person$titles3 = person.titles) === null || _person$titles3 === void 0 ? void 0 : _person$titles3.after_name) && ", ".concat(person === null || person === void 0 ? void 0 : (_person$titles4 = person.titles) === null || _person$titles4 === void 0 ? void 0 : _person$titles4.after_name)]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RowSectionLecturerPosition, {
      children: [person === null || person === void 0 ? void 0 : person.company, (person === null || person === void 0 ? void 0 : (_person$position = person.position) === null || _person$position === void 0 ? void 0 : _person$position.length) > 0 && (person === null || person === void 0 ? void 0 : (_person$company = person.company) === null || _person$company === void 0 ? void 0 : _person$company.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: ", "
      }), person === null || person === void 0 ? void 0 : person.position]
    })]
  });
};

/* harmony default export */ var ConferenceProgramLecturer = (ConferenceProgramLecturerTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceProgram/ConferenceProgramTime.tsx








var ConferenceProgramTimeTemplate = function ConferenceProgramTimeTemplate(_ref) {
  var from = _ref.from,
      to = _ref.to;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(''),
      newFrom = _useState[0],
      setFrom = _useState[1];

  var _useState2 = (0,react.useState)(''),
      newto = _useState2[0],
      setTo = _useState2[1];

  (0,react.useEffect)(function () {
    setFrom(from);
    setTo(to);
  }, [from, to]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RowTime, {
    children: newFrom && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Time, {
        children: moment_default()(newFrom).format('HH:mm')
      }), newto && /*#__PURE__*/(0,jsx_runtime.jsx)(Time, {
        children: " - "
      }), newto && /*#__PURE__*/(0,jsx_runtime.jsx)(Time, {
        children: moment_default()(newto).format('HH:mm')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Time, {
        children: " hod."
      })]
    })
  });
};

/* harmony default export */ var ConferenceProgramTime = (ConferenceProgramTimeTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceProgram/ConferenceProgram.tsx











var ConferenceProgramTemplate = function ConferenceProgramTemplate(_ref) {
  var _conf$conference, _conf$conference$reda, _conf$conference2, _conf$conference3, _conf$conference4;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)('programTab0'),
      activeSection = _useState[0],
      setActiveSection = _useState[1];

  var _useState2 = (0,react.useState)(''),
      showAbstract = _useState2[0],
      setShowAbstract = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isAbstract = _useState3[0],
      setIsAbstract = _useState3[1];

  var onlyModerators = conf === null || conf === void 0 ? void 0 : conf.lectors.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.type) === 0;
  });

  var handleAbstract = function handleAbstract(index, indexPart) {
    if (showAbstract !== "programAbstract".concat(index).concat(indexPart)) {
      setIsAbstract(true);
      setShowAbstract("programAbstract".concat(index).concat(indexPart));
    } else {
      setIsAbstract(false);
      setShowAbstract('');
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceProgram_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.PROGRAM),
    colors: colors,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceProgram_elements_Title, {
      colors: colors,
      children: [t('conference.component.program.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceProgram_elements_TitleSymbol, {
        colors: colors
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceProgram_elements_Description, {
      children: conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : (_conf$conference$reda = _conf$conference.redactorTexts) === null || _conf$conference$reda === void 0 ? void 0 : _conf$conference$reda.programDescription
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.schedule.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceProgram_elements_Tabs, {
      children: conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : _conf$conference3.schedule.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceProgram_elements_Tab, {
          colors: colors,
          className: activeSection === "programTab".concat(index) ? 'active' : '',
          onClick: function onClick() {
            return setActiveSection("programTab".concat(index));
          },
          children: item.title
        }, "scheduleTab".concat(index));
      })
    }), conf === null || conf === void 0 ? void 0 : (_conf$conference4 = conf.conference) === null || _conf$conference4 === void 0 ? void 0 : _conf$conference4.schedule.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Empty, {
        children: activeSection === "programTab".concat(index) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceProgram_elements_Content, {
          children: [onlyModerators.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: onlyModerators.map(function (moderator, index2) {
              var _moderator$titles, _moderator$titles2, _moderator$titles3, _moderator$titles4;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Moderator, {
                children: [moderator.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(ModeratorImage, {
                  src: "".concat((0,constants/* getApiURL */.tU)(), "/media/people/").concat(moderator === null || moderator === void 0 ? void 0 : moderator.photo)
                }), !moderator.photo && /*#__PURE__*/(0,jsx_runtime.jsx)(ModeratorImage, {
                  src: "/public/avatar.svg"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ModeratorDesc, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ModeratorName, {
                    children: [(moderator === null || moderator === void 0 ? void 0 : (_moderator$titles = moderator.titles) === null || _moderator$titles === void 0 ? void 0 : _moderator$titles.before_name) && "".concat(moderator === null || moderator === void 0 ? void 0 : (_moderator$titles2 = moderator.titles) === null || _moderator$titles2 === void 0 ? void 0 : _moderator$titles2.before_name, " "), moderator.name, " ", moderator.surname, (moderator === null || moderator === void 0 ? void 0 : (_moderator$titles3 = moderator.titles) === null || _moderator$titles3 === void 0 ? void 0 : _moderator$titles3.after_name) && ", ".concat(moderator === null || moderator === void 0 ? void 0 : (_moderator$titles4 = moderator.titles) === null || _moderator$titles4 === void 0 ? void 0 : _moderator$titles4.after_name)]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(ModeratorLabel, {
                    children: t('conference.general.moderator.male')
                  })]
                })]
              }, "moderator".concat(index2));
            })
          }), (item === null || item === void 0 ? void 0 : item.part) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: item === null || item === void 0 ? void 0 : item.part.map(function (part, indexPart, parts) {
              var _parts;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Empty, {
                children: [part.block_name && /*#__PURE__*/(0,jsx_runtime.jsxs)(Block, {
                  colors: colors,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BlockNumber, {
                    colors: colors,
                    children: part.block_name
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlockName, {
                    children: [" ", part.block_subheading]
                  })]
                }), !part.block_name && /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceProgram_elements_Row, {
                  withoutBorder: !!((_parts = parts[indexPart + 1]) !== null && _parts !== void 0 && _parts.block_name || (item === null || item === void 0 ? void 0 : item.part.length) === indexPart + 1),
                  children: [part.from && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceProgramTime, {
                      from: part.from,
                      to: part.to
                    })
                  }), !part.from && /*#__PURE__*/(0,jsx_runtime.jsx)(RowTime, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RowContent, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(RowSection, {
                      children: [part.block_name2 && /*#__PURE__*/(0,jsx_runtime.jsx)(BlockPanel, {
                        colors: colors,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BlockPanelLabel, {
                          colors: colors,
                          children: part.block_name2
                        })
                      }), part.nonLecture_name && /*#__PURE__*/(0,jsx_runtime.jsx)(RowSectionTitle, {
                        colors: colors,
                        children: part.nonLecture_name
                      }), part.lecture_name && /*#__PURE__*/(0,jsx_runtime.jsx)(RowSectionTitleLecture, {
                        colors: colors,
                        children: part.lecture_name
                      }), part.description && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [showAbstract !== "programAbstract".concat(index).concat(indexPart) && /*#__PURE__*/(0,jsx_runtime.jsxs)(RowSectionAbstract, {
                          children: [t('conference.general.showAbstract'), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(RowSectionAbstractLink, {
                            colors: colors,
                            onClick: function onClick() {
                              return handleAbstract(index, indexPart);
                            },
                            children: "+"
                          })]
                        }), showAbstract === "programAbstract".concat(index).concat(indexPart) && /*#__PURE__*/(0,jsx_runtime.jsxs)(RowSectionAbstract, {
                          children: [t('conference.general.hideAbstract'), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(RowSectionAbstractLink, {
                            colors: colors,
                            onClick: function onClick() {
                              return handleAbstract(index, indexPart);
                            },
                            children: "-"
                          })]
                        }), isAbstract && showAbstract === "programAbstract".concat(index).concat(indexPart) && /*#__PURE__*/(0,jsx_runtime.jsx)(ContentAbstract, {
                          dangerouslySetInnerHTML: {
                            __html: part === null || part === void 0 ? void 0 : part.description
                          },
                          colors: colors
                        })]
                      }), (part === null || part === void 0 ? void 0 : part.lecturers.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: part === null || part === void 0 ? void 0 : part.lecturers.map(function (lecturer, index) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)(RowSectionLecturer, {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceProgramLecturer, {
                              personKey: lecturer._key,
                              conf: conf
                            })
                          }, "lecturer".concat(index));
                        })
                      })]
                    })
                  })]
                })]
              }, "partContent".concat(indexPart));
            })
          })]
        })
      }, "scheduleContent".concat(index));
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LegislativeLabel, {
      children: t('conference.component.program.rightToChange')
    })]
  });
};

/* harmony default export */ var ConferenceProgram = (ConferenceProgramTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceReferences/ConferenceReferences.elements.tsx



var ConferenceReferences_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReferenceselements__Wrapper",
  componentId: "sc-1322yr5-0"
})(["padding:", " 0 ", " 0;border-bottom:1px solid ", ";.slick-dots{bottom:-30px;li{width:20px;height:20px;button{&:before{font-size:10px;opacity:1;color:", ";}}&.slick-active{button{&:before{color:", ";}}}}}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorNonLecture;
}, function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLink;
});
var ConferenceReferences_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReferenceselements__Title",
  componentId: "sc-1322yr5-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorTitle;
});
var ConferenceReferences_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReferenceselements__TitleSymbol",
  componentId: "sc-1322yr5-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors4;

  return (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferenceReferences_elements_CarouselWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReferenceselements__CarouselWrapper",
  componentId: "sc-1322yr5-3"
})(["padding:", " 0;@media (min-width:", "px){max-width:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(805));
var Reference = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReferenceselements__Reference",
  componentId: "sc-1322yr5-4"
})(["background:", ";text-align:center;padding:", ";width:100% !important;"], function (props) {
  var _props$colors5;

  return (_props$colors5 = props.colors) === null || _props$colors5 === void 0 ? void 0 : _props$colors5.colorLightest;
}, (0,polished_esm/* rem */.hO)(10));
var ConferenceReferences_elements_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceReferenceselements__Description",
  componentId: "sc-1322yr5-5"
})(["padding-bottom:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(18));
var Author = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReferenceselements__Author",
  componentId: "sc-1322yr5-6"
})(["display:block;color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.grey;
});
var Company = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReferenceselements__Company",
  componentId: "sc-1322yr5-7"
})(["color:", ";display:block;padding-bottom:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(5));
var ConferenceReferences_elements_LegislativeLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReferenceselements__LegislativeLabel",
  componentId: "sc-1322yr5-8"
})(["color:", ";display:block;margin-top:", ";font-size:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(25), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.textBase;
});
;// CONCATENATED MODULE: ./src/components/ConferenceReferences/ConferenceReferences.tsx


function ConferenceReferences_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ConferenceReferences_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ConferenceReferences_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ConferenceReferences_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var ConferenceReferencesTemplate = function ConferenceReferencesTemplate(_ref) {
  var _conf$conference, _conf$conference2;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    responsive: [{
      breakpoint: theme/* breakpoints.xs */.A.xs,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    }, {
      breakpoint: theme/* breakpoints.sm */.A.sm,
      settings: {
        slidesToShow: 2,
        dots: true
      }
    }, {
      breakpoint: theme/* breakpoints.md */.A.md,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    }]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReferences_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.REFERENCES),
    colors: colors,
    children: (conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.references.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceReferences_elements_Title, {
        colors: colors,
        children: [t('conference.component.references.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReferences_elements_TitleSymbol, {
          colors: colors
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReferences_elements_CarouselWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, ConferenceReferences_objectSpread(ConferenceReferences_objectSpread({}, settings), {}, {
          children: conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.references.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(Reference, {
              colors: colors,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReferences_elements_Description, {
                children: item.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Author, {
                children: item.author
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Company, {
                children: item.company
              })]
            }, "".concat(index));
          })
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReferences_elements_LegislativeLabel, {
        children: t('conference.component.references.origin')
      })]
    })
  });
};

/* harmony default export */ var ConferenceReferences = (ConferenceReferencesTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceReportageVideo/ConferenceReportageVideo.elements.tsx



var ConferenceReportageVideo_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__Wrapper",
  componentId: "sc-fff4cm-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15));
var ConferenceReportageVideo_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReportageVideoelements__Title",
  componentId: "sc-fff4cm-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorTitle;
});
var ConferenceReportageVideo_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReportageVideoelements__TitleSymbol",
  componentId: "sc-fff4cm-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferenceReportageVideo_elements_Tabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__Tabs",
  componentId: "sc-fff4cm-3"
})(["display:flex;border-bottom:1px solid ", ";margin-top:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var ConferenceReportageVideo_elements_Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__Tab",
  componentId: "sc-fff4cm-4"
})(["margin-right:", ";color:", ";cursor:pointer;&.active{font-weight:", ";border-bottom:2px solid ", ";padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(30), function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLink;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors4;

  return (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorLink;
}, (0,polished_esm/* rem */.hO)(10));
var ConferenceReportageVideo_elements_Conference = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__Conference",
  componentId: "sc-fff4cm-5"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(30));
var ConferenceReportageVideo_elements_ConferenceLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ConferenceReportageVideoelements__ConferenceLink",
  componentId: "sc-fff4cm-6"
})(["font-weight:", ";color:", ";cursor:pointer;text-decoration:none;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors5;

  return (_props$colors5 = props.colors) === null || _props$colors5 === void 0 ? void 0 : _props$colors5.colorLink;
});
var ConferenceReportageVideo_elements_Record = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__Record",
  componentId: "sc-fff4cm-7"
})([""]);
var ConferenceReportageVideo_elements_RecordLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReportageVideoelements__RecordLabel",
  componentId: "sc-fff4cm-8"
})(["font-weight:", ";display:block;padding-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10));
var ConferenceReportageVideo_elements_Source = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ConferenceReportageVideoelements__Source",
  componentId: "sc-fff4cm-9"
})(["color:", ";font-size:", ";padding:", " 0;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(10));
var ConferenceReportageVideo_elements_Gallery = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__Gallery",
  componentId: "sc-fff4cm-10"
})([""]);
var ConferenceReportageVideo_elements_GalleryLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReportageVideoelements__GalleryLabel",
  componentId: "sc-fff4cm-11"
})(["font-weight:", ";display:block;padding-bottom:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(5));
var ConferenceReportageVideo_elements_GalleryDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceReportageVideoelements__GalleryDescription",
  componentId: "sc-fff4cm-12"
})([""]);
var ConferenceReportageVideo_elements_GalleryImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ConferenceReportageVideoelements__GalleryImage",
  componentId: "sc-fff4cm-13"
})(["width:95% !important;cursor:pointer;"]);
var ConferenceReportageVideo_elements_CarouselWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__CarouselWrapper",
  componentId: "sc-fff4cm-14"
})(["padding:", " 0;@media (min-width:", "px){max-width:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(805));
var ConferenceReportageVideo_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__Content",
  componentId: "sc-fff4cm-15"
})([""]);
var ConferenceReportageVideo_elements_RecordContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__RecordContent",
  componentId: "sc-fff4cm-16"
})(["display:flex;flex-direction:column;width:100%;height:450px;padding:", " ", ";align-items:center;@media (max-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm);
var ConferenceReportageVideo_elements_EmbedContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceReportageVideoelements__EmbedContent",
  componentId: "sc-fff4cm-17"
})(["position:relative;display:block;width:100%;height:100%;padding:0;overflow:hidden;"]);
var ConferenceReportageVideo_elements_Embed = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "ConferenceReportageVideoelements__Embed",
  componentId: "sc-fff4cm-18"
})(["position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0;"]);
;// CONCATENATED MODULE: ./src/components/ConferenceReportageVideo/ConferenceReportageVideo.tsx









var ConferenceReportageVideoTemplate = function ConferenceReportageVideoTemplate(_ref) {
  var _conf$conference, _conf$conference2;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceReportageVideo_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.REPORTAGEVIDEO),
    colors: colors,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceReportageVideo_elements_Title, {
      colors: colors,
      children: [t('conference.component.reportagevideo.title'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReportageVideo_elements_TitleSymbol, {
        colors: colors
      })]
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.url_youtube) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReportageVideo_elements_Record, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReportageVideo_elements_RecordContent, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReportageVideo_elements_EmbedContent, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReportageVideo_elements_Embed, {
              src: conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.url_youtube
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReportageVideo_elements_Source, {
        children: t('conference.general.sourcePP')
      })]
    })]
  });
};

/* harmony default export */ var ConferenceReportageVideo = (ConferenceReportageVideoTemplate);
// EXTERNAL MODULE: ./src/components/CartSupport/Support.tsx + 1 modules
var Support = __webpack_require__(28624);
// EXTERNAL MODULE: ./src/hooks/useCart.tsx + 1 modules
var useCart = __webpack_require__(44722);
// EXTERNAL MODULE: ./src/ui/Tag/Tag.tsx + 1 modules
var Tag = __webpack_require__(67279);
;// CONCATENATED MODULE: ./src/components/ConferenceTickets/ConferenceTickets.elements.tsx



var ConferenceTickets_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceTicketselements__Wrapper",
  componentId: "sc-esslgl-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15));
var ConferenceTickets_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__Title",
  componentId: "sc-esslgl-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  return props.colors.colorTitle;
});
var ConferenceTickets_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TitleSymbol",
  componentId: "sc-esslgl-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  return props.colors.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var Tickets = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceTicketselements__Tickets",
  componentId: "sc-esslgl-3"
})(["display:flex;flex-direction:column;gap:", ";margin-bottom:", ";justify-content:space-between;@media (min-width:", "px){flex-direction:row;&::-webkit-scrollbar{display:none;}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
var ConferenceTickets_elements_Ticket = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceTicketselements__Ticket",
  componentId: "sc-esslgl-4"
})(["background:", ";display:flex;flex-direction:column;text-align:center;padding-bottom:", ";width:50%;&:hover{background:", ";}@media (max-width:", "px){width:100%;}"], function (props) {
  return props.colors.colorLightest;
}, (0,polished_esm/* rem */.hO)(25), function (props) {
  return props.colors.colorLight;
}, theme/* breakpoints.sm */.A.sm);
var ConferenceTickets_elements_TicketTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TicketTitle",
  componentId: "sc-esslgl-5"
})(["background:", ";color:", ";font-weight:", ";font-size:", ";padding:", " ", " ", " ", ";"], function (props) {
  return props.colors.colorLink;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10));
var TicketLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TicketLabel",
  componentId: "sc-esslgl-6"
})(["background:", ";color:", ";padding:0 0 ", " 0;"], function (props) {
  return props.colors.colorLink;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(15));
var TicketQuestion = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TicketQuestion",
  componentId: "sc-esslgl-7"
})(["font-weight:", ";padding:", " ", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(10));
var TicketAnswers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceTicketselements__TicketAnswers",
  componentId: "sc-esslgl-8"
})(["padding:0 ", ";text-align:left;line-height:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(25));
var TicketAnswer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceTicketselements__TicketAnswer",
  componentId: "sc-esslgl-9"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(10));
var TicketPriceWithButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceTicketselements__TicketPriceWithButton",
  componentId: "sc-esslgl-10"
})(["margin-top:auto;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
var ConferenceTickets_elements_TicketPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TicketPrice",
  componentId: "sc-esslgl-11"
})(["font-weight:", ";font-size:", ";padding:", " 0 0 0;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeights.textBold;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(20));
var TicketPriceNoVat = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TicketPriceNoVat",
  componentId: "sc-esslgl-12"
})(["font-weight:", ";font-size:", ";padding:", " 0 ", " 0;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeights.textRegular;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSizes.h7;
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(20));
var TicketButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ConferenceTicketselements__TicketButton",
  componentId: "sc-esslgl-13"
})(["padding:", " ", ";margin:0 auto;width:", ";border-radius:", ";cursor:pointer;border:none;background:", ";color:", ";font-weight:", ";&:hover{background:", ";}@media (min-width:", "px){margin:0 ", ";}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(200), (0,polished_esm/* rem */.hO)(4), function (props) {
  return props.colors.colorButton;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.white;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  return props.colors.colorButtonHover;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(10));
var TicketSoldOut = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TicketSoldOut",
  componentId: "sc-esslgl-14"
})(["font-weight:", ";font-size:", ";padding:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontWeights.textBold;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(20));
var TicketCanceled = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceTicketselements__TicketCanceled",
  componentId: "sc-esslgl-15"
})(["font-weight:", ";font-size:", ";padding:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontWeights.textBold;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(20));
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceTicketselements__Tags",
  componentId: "sc-esslgl-16"
})(["margin-top:", ";padding:", " 0;@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.md */.A.md);
;// CONCATENATED MODULE: ./src/components/ConferenceTickets/ConferenceTicket.tsx














var ConferenceTicketTemplate = function ConferenceTicketTemplate(_ref) {
  var _ticket$date4, _date$modules, _date$eventDate, _date$eventDate2, _date$eventDate3, _date$eventDate4, _date$eventDate6, _date$eventDate7, _date$tags, _date$tags$filter, _date$tags2, _date$tags2$filter;

  var colors = _ref.colors,
      ticket = _ref.ticket,
      type = _ref.type;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useCart = (0,useCart/* default */.ZP)(),
      addOrUpdateItemInCart = _useCart.addOrUpdateItemInCart;

  var _useState = (0,react.useState)(),
      date = _useState[0],
      setDate = _useState[1];

  var _useState2 = (0,react.useState)({}),
      quantities = _useState2[0],
      setQuantities = _useState2[1];

  var loadDateByKey = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dateKey) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return calendar_service/* calendarApi.getDateData */.w.getDateData(dateKey);

            case 2:
              response = _context.sent;
              setDate(response.data);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadDateByKey(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var _ticket$date;

    if (ticket !== null && ticket !== void 0 && (_ticket$date = ticket.date) !== null && _ticket$date !== void 0 && _ticket$date._key) {
      var _ticket$date2, _ticket$date3;

      loadDateByKey(ticket === null || ticket === void 0 ? void 0 : (_ticket$date2 = ticket.date) === null || _ticket$date2 === void 0 ? void 0 : _ticket$date2._key);
      quantities[ticket === null || ticket === void 0 ? void 0 : (_ticket$date3 = ticket.date) === null || _ticket$date3 === void 0 ? void 0 : _ticket$date3._key] = 1;
      setQuantities(quantities);
    }
  }, [ticket === null || ticket === void 0 ? void 0 : (_ticket$date4 = ticket.date) === null || _ticket$date4 === void 0 ? void 0 : _ticket$date4._key]);
  var priceTicket = date === null || date === void 0 ? void 0 : (_date$modules = date.modules) === null || _date$modules === void 0 ? void 0 : _date$modules.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.type) === 0;
  });
  var a = moment_default()(date === null || date === void 0 ? void 0 : (_date$eventDate = date.eventDate) === null || _date$eventDate === void 0 ? void 0 : _date$eventDate.to);
  var b = moment_default()(date === null || date === void 0 ? void 0 : (_date$eventDate2 = date.eventDate) === null || _date$eventDate2 === void 0 ? void 0 : _date$eventDate2.from);
  var diffDays = a.diff(b, 'days') + 1;

  var handleBuyClick = function handleBuyClick() {
    var top = document.getElementById('confSection14').offsetTop;
    return window.scrollTo({
      top: top - 60,
      behavior: 'smooth'
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceTickets_elements_Ticket, {
    colors: colors,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceTickets_elements_TicketTitle, {
      colors: colors,
      children: ticket.name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketLabel, {
      colors: colors,
      children: diffDays > 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["(", diffDays, " ", t('conference.general.dayOfConference'), ")"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketQuestion, {
      children: t('conference.general.ticketInclude')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketAnswers, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TicketAnswer, {
        dangerouslySetInnerHTML: {
          __html: ticket.description
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketPriceWithButton, {
      children: [(priceTicket === null || priceTicket === void 0 ? void 0 : priceTicket.length) > 0 && (date === null || date === void 0 ? void 0 : (_date$eventDate3 = date.eventDate) === null || _date$eventDate3 === void 0 ? void 0 : _date$eventDate3.state) === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceTickets_elements_TicketPrice, {
          children: [(0,cart_utils/* formatMoneyToCZK */.DM)(priceTicket[0].price_with_vat), " ", t('conference.general.currencySign'), ' ', t('conference.general.withVat')]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TicketPriceNoVat, {
          children: [(0,cart_utils/* formatMoneyToCZK */.DM)(priceTicket[0].price), " ", t('conference.general.currencySign'), ' ', t('conference.general.noVat')]
        })]
      }), (date === null || date === void 0 ? void 0 : (_date$eventDate4 = date.eventDate) === null || _date$eventDate4 === void 0 ? void 0 : _date$eventDate4.state) === 0 && type !== 3 && /*#__PURE__*/(0,jsx_runtime.jsx)(TicketButton, {
        colors: colors,
        onClick: function onClick() {
          var _priceTicket$, _date$eventDate5;

          return addOrUpdateItemInCart((_priceTicket$ = priceTicket[0]) === null || _priceTicket$ === void 0 ? void 0 : _priceTicket$._key, quantities[date === null || date === void 0 ? void 0 : (_date$eventDate5 = date.eventDate) === null || _date$eventDate5 === void 0 ? void 0 : _date$eventDate5._key]);
        },
        children: t('conference.general.buyTicket')
      }), (date === null || date === void 0 ? void 0 : (_date$eventDate6 = date.eventDate) === null || _date$eventDate6 === void 0 ? void 0 : _date$eventDate6.state) === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(TicketSoldOut, {
        children: t('conference.general.soldOut')
      }), (date === null || date === void 0 ? void 0 : (_date$eventDate7 = date.eventDate) === null || _date$eventDate7 === void 0 ? void 0 : _date$eventDate7.state) === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(TicketCanceled, {
        children: t('conference.general.canceled')
      })]
    }), (date === null || date === void 0 ? void 0 : (_date$tags = date.tags) === null || _date$tags === void 0 ? void 0 : (_date$tags$filter = _date$tags.filter(function (tag) {
      return tag === null || tag === void 0 ? void 0 : tag.label;
    })) === null || _date$tags$filter === void 0 ? void 0 : _date$tags$filter.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Tags, {
      children: date === null || date === void 0 ? void 0 : (_date$tags2 = date.tags) === null || _date$tags2 === void 0 ? void 0 : (_date$tags2$filter = _date$tags2.filter(function (tag) {
        return tag.label;
      })) === null || _date$tags2$filter === void 0 ? void 0 : _date$tags2$filter.map(function (tag, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
          name: tag.title,
          color: tag.color
        }, "tag-".concat(key));
      })
    })]
  });
};

/* harmony default export */ var ConferenceTicket = (ConferenceTicketTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceTickets/ConferenceTickets.tsx










var ConferenceTicketsTemplate = function ConferenceTicketsTemplate(_ref) {
  var _conf$conference, _conf$conference2, _conf$conference2$tic;

  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceTickets_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.TICKETS),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceTickets_elements_Title, {
      colors: colors,
      children: [t('conference.component.tickets.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceTickets_elements_TitleSymbol, {
        colors: colors
      })]
    }), (conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.tickets.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tickets, {
        children: conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : (_conf$conference2$tic = _conf$conference2.tickets) === null || _conf$conference2$tic === void 0 ? void 0 : _conf$conference2$tic.map(function (item, index) {
          var _conf$conference3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceTicket, {
            colors: colors,
            ticket: item,
            type: conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : _conf$conference3.type
          }, "ticket".concat(index));
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Support/* default */.Z, {
      withoutMargin: true,
      withoutBackground: true
    })]
  });
};

/* harmony default export */ var ConferenceTickets = (ConferenceTicketsTemplate);
// EXTERNAL MODULE: ./src/utils/time.utils.ts
var time_utils = __webpack_require__(775);
;// CONCATENATED MODULE: ./src/components/ConferenceVideo/ConferenceVideo.elements.tsx




var ConferenceVideo_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceVideoelements__Wrapper",
  componentId: "sc-6fuaj-0"
})(["padding:", " ", " ", " ", ";background:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), function (props) {
  var _props$colors;

  return (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.colorLightest;
});
var ConferenceVideo_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceVideoelements__Title",
  componentId: "sc-6fuaj-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  var _props$colors2;

  return (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.colorTitle;
});
var ConferenceVideo_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceVideoelements__TitleSymbol",
  componentId: "sc-6fuaj-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  var _props$colors3;

  return (_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
var ConferenceVideo_elements_Tabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceVideoelements__Tabs",
  componentId: "sc-6fuaj-3"
})(["display:flex;border-bottom:1px solid ", ";margin-top:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var ConferenceVideo_elements_Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceVideoelements__Tab",
  componentId: "sc-6fuaj-4"
})(["margin-right:", ";color:", ";cursor:pointer;&.active{font-weight:", ";border-bottom:2px solid ", ";padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(30), function (props) {
  var _props$colors4;

  return (_props$colors4 = props.colors) === null || _props$colors4 === void 0 ? void 0 : _props$colors4.colorLink;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  var _props$colors5;

  return (_props$colors5 = props.colors) === null || _props$colors5 === void 0 ? void 0 : _props$colors5.colorLink;
}, (0,polished_esm/* rem */.hO)(10));
var ConferenceVideo_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceVideoelements__Content",
  componentId: "sc-6fuaj-5"
})(["margin:0 ", ";"], (0,polished_esm/* rem */.hO)(10));
var Chapters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceVideoelements__Chapters",
  componentId: "sc-6fuaj-6"
})(["width:100%;@media (max-width:", "px){width:100%;padding-left:0;}"], theme/* breakpoints.sm */.A.sm);
var Chapter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceVideoelements__Chapter",
  componentId: "sc-6fuaj-7"
})(["cursor:pointer;display:flex;padding-bottom:", ";align-items:center;"], (0,polished_esm/* rem */.hO)(5));
var ChapterTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceVideoelements__ChapterTime",
  componentId: "sc-6fuaj-8"
})(["width:", ";text-align:right;font-size:", ";", ";"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(14), function (prop) {
  var _prop$colors, _prop$colors2;

  return prop.isActive ? "color: ".concat((_prop$colors = prop.colors) === null || _prop$colors === void 0 ? void 0 : _prop$colors.colorLink) : "color: ".concat((_prop$colors2 = prop.colors) === null || _prop$colors2 === void 0 ? void 0 : _prop$colors2.colorVideoLink);
});
var ChapterIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "ConferenceVideoelements__ChapterIcon",
  componentId: "sc-6fuaj-9"
})(["padding:0 ", " 0 ", ";svg{width:", ";height:", ";path{", ";}}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (prop) {
  var _prop$colors3, _prop$colors4;

  return prop.isActive ? "fill: ".concat((_prop$colors3 = prop.colors) === null || _prop$colors3 === void 0 ? void 0 : _prop$colors3.colorLink) : "fill: ".concat((_prop$colors4 = prop.colors) === null || _prop$colors4 === void 0 ? void 0 : _prop$colors4.colorVideoLink);
});
var ChapterTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceVideoelements__ChapterTitle",
  componentId: "sc-6fuaj-10"
})(["", ";"], function (prop) {
  var _prop$colors5, _prop$colors6;

  return prop.isActive ? "color: ".concat((_prop$colors5 = prop.colors) === null || _prop$colors5 === void 0 ? void 0 : _prop$colors5.colorLink) : "color: ".concat((_prop$colors6 = prop.colors) === null || _prop$colors6 === void 0 ? void 0 : _prop$colors6.colorVideoLink);
});
var ConferenceVideo_elements_Author = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceVideoelements__Author",
  componentId: "sc-6fuaj-11"
})(["margin:", " 0;font-size:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(13));
var ConferenceVideo_elements_InfoMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceVideoelements__InfoMessage",
  componentId: "sc-6fuaj-12"
})(["color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
;// CONCATENATED MODULE: ./src/components/ConferenceVideo/ConferenceVideo.tsx
function ConferenceVideo_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = ConferenceVideo_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function ConferenceVideo_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ConferenceVideo_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ConferenceVideo_arrayLikeToArray(o, minLen); }

function ConferenceVideo_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











var ConferenceVideoTemplate = function ConferenceVideoTemplate(_ref) {
  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)('videosTab0'),
      activeSection = _useState[0],
      setActiveSection = _useState[1];

  var _useState2 = (0,react.useState)(''),
      activeChapter = _useState2[0],
      setActiveChapter = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      videos = _useState3[0],
      setVideos = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      termAccessible = _useState4[0],
      setTermAccessible = _useState4[1];

  (0,react.useEffect)(function () {
    if (conf) {
      var _iterator = ConferenceVideo_createForOfIteratorHelper(conf === null || conf === void 0 ? void 0 : conf.dates),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var date = _step.value;

          if (date.accessible) {
            var _iterator3 = ConferenceVideo_createForOfIteratorHelper(date.videos),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var video = _step3.value;
                videos.push(video);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var videosUnique = videos.filter(function (value, index, self) {
        return self.map(function (x) {
          return x._key;
        }).indexOf(value._key) == index;
      });
      setVideos(videosUnique);

      var _iterator2 = ConferenceVideo_createForOfIteratorHelper(conf === null || conf === void 0 ? void 0 : conf.dates),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _date = _step2.value;

          if (_date.accessible) {
            setTermAccessible(true);
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, [conf]);

  var handleClick = function handleClick(e, time, index, index2) {
    var videoElement = document.getElementById("recordVideo".concat(index));
    videoElement.currentTime = time;
    setActiveChapter("chapter".concat(index).concat(index2));
    e.preventDefault();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceVideo_elements_Wrapper, {
    id: "confSection".concat(COMPONENT_TYPE.VIDEO),
    colors: colors,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceVideo_elements_Title, {
      colors: colors,
      children: [t('conference.component.record.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceVideo_elements_TitleSymbol, {
        colors: colors
      })]
    }), videos.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [(videos === null || videos === void 0 ? void 0 : videos.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceVideo_elements_Tabs, {
          children: videos === null || videos === void 0 ? void 0 : videos.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceVideo_elements_Tab, {
                colors: colors,
                className: activeSection === "videosTab".concat(index) ? 'active' : '',
                onClick: function onClick() {
                  return setActiveSection("videosTab".concat(index));
                },
                children: [index + 1, ". ", t('conference.general.record')]
              })
            });
          })
        })
      }), videos === null || videos === void 0 ? void 0 : videos.map(function (item, index) {
        var _item$chapters;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: activeSection === "videosTab".concat(index) && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceVideo_elements_Content, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [(item === null || item === void 0 ? void 0 : item.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
                width: "100%",
                controls: true,
                id: "recordVideo".concat(index),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
                  src: item === null || item === void 0 ? void 0 : item.url,
                  type: "video/mp4"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceVideo_elements_Author, {
                children: t('conference.general.sourcePP')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Chapters, {
                children: item === null || item === void 0 ? void 0 : (_item$chapters = item.chapters) === null || _item$chapters === void 0 ? void 0 : _item$chapters.map(function (item2, index2) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Chapter, {
                    onClick: function onClick(e) {
                      return handleClick(e, item2.time, index, index2);
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ChapterTime, {
                      colors: colors,
                      isActive: activeChapter === "chapter".concat(index).concat(index2),
                      children: (0,time_utils/* secondsToHMS */.ki)(item2.time)
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterIcon, {
                      name: Icon/* Icons.Play */.PJ.Play,
                      colors: colors,
                      isActive: activeChapter === "chapter".concat(index).concat(index2)
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterTitle, {
                      colors: colors,
                      isActive: activeChapter === "chapter".concat(index).concat(index2),
                      children: [index2 + 1, ". ", item2.title]
                    })]
                  }, "chapterKey".concat(index).concat(index2));
                })
              })]
            })
          })
        });
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceVideo_elements_Content, {
      children: [termAccessible && videos.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceVideo_elements_InfoMessage, {
        children: t('conference.component.record.anyRecords.accessible')
      }), !termAccessible && videos.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceVideo_elements_InfoMessage, {
        children: t('conference.component.record.anyRecords')
      })]
    })]
  });
};

/* harmony default export */ var ConferenceVideo = (ConferenceVideoTemplate);
;// CONCATENATED MODULE: ./src/components/ConferenceStream/ConferenceStream.elements.tsx


var ConferenceStream_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ConferenceStreamelements__Wrapper",
  componentId: "sc-nw1br-0"
})(["padding:", " 0 ", " 0;position:relative;overflow:hidden;border-bottom-left-radius:", ";border-bottom-right-radius:", ";display:flex;flex-direction:column;"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(12));
var ConferenceStream_elements_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceStreamelements__Title",
  componentId: "sc-nw1br-1"
})(["padding-bottom:", ";display:inline-block;font-weight:", ";font-size:", ";position:relative;color:", ";"], (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (props) {
  return props.colors.colorTitle;
});
var ConferenceStream_elements_TitleSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ConferenceStreamelements__TitleSymbol",
  componentId: "sc-nw1br-2"
})(["position:absolute;width:", ";height:", ";background:", ";left:0;bottom:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(5), function (props) {
  return props.colors.colorLine;
}, (0,polished_esm/* rem */.hO)(15));
// EXTERNAL MODULE: ./node_modules/video.js/dist/video.es.js
var video_es = __webpack_require__(85215);
// EXTERNAL MODULE: ./node_modules/video.js/dist/video-js.css
var video_js = __webpack_require__(32090);
;// CONCATENATED MODULE: ./src/ui/VideoJS/videojs.tsx




var VideoJS = function VideoJS(props) {
  var videoRef = react.useRef(null);
  var playerRef = react.useRef(null);
  var options = props.options,
      onReady = props.onReady;
  react.useEffect(function () {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
      var videoElement = document.createElement("video-js");
      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current.appendChild(videoElement);
      var player = playerRef.current = (0,video_es/* default */.Z)(videoElement, options, function () {
        video_es/* default.log */.Z.log('player is ready');
        onReady && onReady(player);
      }); // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      var _player = playerRef.current;

      _player.autoplay(options.autoplay);

      _player.src(options.sources);
    }
  }, [options, videoRef]); // Dispose the Video.js player when the functional component unmounts

  react.useEffect(function () {
    var player = playerRef.current;
    return function () {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-vjs-player": true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: videoRef
    })
  });
};
/* harmony default export */ var videojs = (VideoJS);
;// CONCATENATED MODULE: ./src/components/ConferenceStream/ConferenceStream.tsx



function ConferenceStream_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = ConferenceStream_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function ConferenceStream_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ConferenceStream_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ConferenceStream_arrayLikeToArray(o, minLen); }

function ConferenceStream_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
















var ConferenceStream_ConferenceHeaderTemplate = function ConferenceHeaderTemplate(_ref) {
  var colors = _ref.colors,
      conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });

  var _useState = (0,react.useState)(false),
      isLoggedIn = _useState[0],
      setIsLoggedIn = _useState[1];

  var _useState2 = (0,react.useState)(false),
      termAccessible = _useState2[0],
      setTermAccessible = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      startConf = _useState3[0],
      setStartConf = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      endConf = _useState4[0],
      setEndConf = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      validUrl = _useState5[0],
      setValidUrl = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isStreamingDay = _useState6[0],
      setIsStreamingDay = _useState6[1];

  var _useState7 = (0,react.useState)(''),
      todayStart = _useState7[0],
      setTodayStart = _useState7[1];

  var _useState8 = (0,react.useState)(''),
      todayEnd = _useState8[0],
      setTodayEnd = _useState8[1];

  var _useState9 = (0,react.useState)(''),
      nextDayStart = _useState9[0],
      setNextDayStart = _useState9[1];

  var _useState10 = (0,react.useState)([]),
      times = _useState10[0],
      setTimes = _useState10[1];

  var playerRef = react.useRef(null);

  var _useState11 = (0,react.useState)({}),
      streamOptions = _useState11[0],
      setStreamOptions = _useState11[1];

  var handlePlayerReady = function handlePlayerReady(player) {
    playerRef.current = player;
  };

  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);
  (0,react.useEffect)(function () {
    if (conf) {
      var _iterator = ConferenceStream_createForOfIteratorHelper(conf === null || conf === void 0 ? void 0 : conf.dates),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.accessible && item.date.conference_stream_days) {
            setTimes(item.date.conference_stream_days);
            setTermAccessible(true);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, [conf]);
  (0,react.useEffect)(function () {
    if (times.length > 0) {
      var startTimeDays = times.map(function (item) {
        return item.from;
      });
      var startTimes = startTimeDays.reduce(function (a, b) {
        return a < b ? a : b;
      });
      setStartConf(startTimes);
      var endTimeDays = times.map(function (item) {
        return item.to;
      });
      var endTimes = endTimeDays.reduce(function (a, b) {
        return a > b ? a : b;
      });
      setEndConf(endTimes);
      var todayStream = times.filter(function (item) {
        return moment_default()(item === null || item === void 0 ? void 0 : item.from).format('D.M.YYYY') == moment_default()().format('D.M.YYYY');
      });

      if (todayStream.length === 1) {
        setIsStreamingDay(true);
        setTodayStart(todayStream[0].from);
        setTodayEnd(todayStream[0].to);
        handleCheckUrl("".concat(todayStream[0].url, ".m3u8"));
      }

      var nextDay = moment_default()().subtract(-1, 'd');
      var arrDays = times.map(function (item) {
        return moment_default()(item === null || item === void 0 ? void 0 : item.from).format('D.M.YYYY');
      });
      var nextDayIndex = arrDays.indexOf(moment_default()(nextDay).format('D.M.YYYY'));

      if (nextDayIndex !== -1) {
        setNextDayStart(times[nextDayIndex].from);
      }
    }
  }, [times]);

  var handleCheckUrl = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(url);

            case 3:
              response = _context.sent;

              if (response.status == 200) {
                setStreamOptions({
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: url,
                    type: 'application/x-mpegURL'
                  }]
                });
                setValidUrl(true);
              } else {
                setValidUrl(false);
              }

              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function handleCheckUrl(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceStream_elements_Wrapper, {
      id: "confSection".concat(COMPONENT_TYPE.STREAM),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ConferenceStream_elements_Title, {
        colors: colors,
        children: [t('conference.component.stream.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceStream_elements_TitleSymbol, {
          colors: colors
        })]
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && !termAccessible && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [t('conference.stream.noAccess'), "."]
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && validUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(videojs, {
        options: streamOptions,
        onReady: handlePlayerReady
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && !validUrl && isStreamingDay && moment_default()() <= moment_default()(todayStart) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [t('conference.stream.beginToday'), " ", t('general.about'), " ", moment_default()(todayStart).format('HH:mm'), "."]
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && !validUrl && isStreamingDay && moment_default()() > moment_default()(todayStart) && moment_default()() < moment_default()(todayEnd) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [t('conference.stream.progress'), "."]
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && !validUrl && isStreamingDay && moment_default()() > moment_default()(todayEnd) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [t('conference.stream.endToday'), !nextDayStart && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "."
        }), nextDayStart && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [", ", t('conference.stream.nextday'), " ", moment_default()(nextDayStart).format('D. M. YYYY'), " ", t('general.about'), " ", moment_default()(nextDayStart).format('H:mm'), "."]
        })]
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && !validUrl && !isStreamingDay && moment_default()(startConf) >= moment_default()() && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [t('conference.stream.begin'), " ", moment_default()(startConf).format('D. M. YYYY'), " ", t('general.about'), " ", moment_default()(startConf).format('H:mm'), "."]
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && !validUrl && !isStreamingDay && moment_default()(nextDayStart) >= moment_default()() && nextDayStart != startConf && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [t('conference.stream.continue'), " ", moment_default()(nextDayStart).format('D. M. YYYY'), " ", t('general.about'), " ", moment_default()(nextDayStart).format('H:mm'), "."]
      }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && !validUrl && !isStreamingDay && moment_default()() >= moment_default()(endConf) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [t('conference.stream.end'), " "]
      })]
    })
  });
};

/* harmony default export */ var ConferenceStream = (ConferenceStream_ConferenceHeaderTemplate);
;// CONCATENATED MODULE: ./src/utils/conference.utils.ts



var _useTranslations = (0,useTranslation/* default */.Z)(),
    t = _useTranslations.t;

var getConferenceTypeTranslationById = function getConferenceTypeTranslationById(id) {
  if (id === CONFERENCE_TYPE.EPI) return 'Epi konferencia';
  if (id === CONFERENCE_TYPE.PP) return 'PP konferencia';
  if (id === CONFERENCE_TYPE.DNA) return 'DNA lídra';
  if (id === CONFERENCE_TYPE.CSKONGRES) return 'CS kongres';
};
var getTypeTranslationById = function getTypeTranslationById(id) {
  if (id === COMPONENT_TYPE.HERO) return t('conference.component.hero.title');
  if (id === COMPONENT_TYPE.PERSONS) return t('conference.component.lecturers.title');
  if (id === COMPONENT_TYPE.PROGRAM) return t('conference.component.program.title');
  if (id === COMPONENT_TYPE.INVITATIONS) return t('conference.component.videoInventions.title');
  if (id === COMPONENT_TYPE.TICKETS) return t('conference.component.tickets.title');
  if (id === COMPONENT_TYPE.ACCOMODATION) return t('conference.component.accomodation.title');
  if (id === COMPONENT_TYPE.PARTNERS) return t('conference.component.partners.title');
  if (id === COMPONENT_TYPE.ARCHIVE) return t('conference.component.previous.title');
  if (id === COMPONENT_TYPE.REFERENCES) return t('conference.component.references.title');
  if (id === COMPONENT_TYPE.ATTACHMENTS) return t('conference.component.attachments.title');
  if (id === COMPONENT_TYPE.VIDEO) return t('conference.component.record.title');
  if (id === COMPONENT_TYPE.ABOUT) return t('conference.component.description.title');
  if (id === COMPONENT_TYPE.NOTICERECORDING) return t('conference.component.digitalRecordInfo.title');
  if (id === COMPONENT_TYPE.CONTACT) return t('conference.component.contact.title');
  if (id === COMPONENT_TYPE.ORDERFORMTICKET) return t('conference.component.orderForm.title');
  if (id === COMPONENT_TYPE.OPENEVENT) return t('conference.component.openEvent.title');
  if (id === COMPONENT_TYPE.PHOTOGALLERY) return t('conference.component.photogallery.title');
  if (id === COMPONENT_TYPE.REPORTAGEVIDEO) return t('conference.component.reportagevideo.title');
  if (id === COMPONENT_TYPE.STREAM) return t('conference.component.stream.title');
};
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content_Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/components/Conference/Conference.elements.tsx





var Desktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__Desktop",
  componentId: "sc-mdjsab-0"
})(["flex-direction:row;justify-content:space-between;gap:", ";display:flex;margin-top:", ";@media (min-width:", "px){margin-top:", ";}@media (max-width:", "px){display:block;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), theme/* breakpoints.md */.A.md);
var NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__NoData",
  componentId: "sc-mdjsab-1"
})(["flex-direction:row;justify-content:space-between;gap:", ";display:flex;margin-top:", ";margin-left:", ";margin-right:", ";@media (min-width:", "px){margin-top:", ";margin-left:", ";margin-right:", ";}@media (max-width:", "px){display:block;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md);
var Conference_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__Content",
  componentId: "sc-mdjsab-2"
})(["padding:0 ", ";width:100%;"], (0,polished_esm/* rem */.hO)(10));
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__Section",
  componentId: "sc-mdjsab-3"
})([""]);
var Sidebar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__Sidebar",
  componentId: "sc-mdjsab-4"
})(["width:100%;background:", ";border-bottom:1px solid ", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";padding:", ";margin:", " 0;display:flex;flex-direction:column;", ";top:", ";z-index:9;@media (min-width:", "px){top:", ";}@media (min-width:", "px){position:sticky;height:fit-content;border:1px solid ", ";border-radius:", ";min-width:", ";max-width:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(0), function (prop) {
  return prop.isHide ? "position: relative" : "position: fixed";
}, (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), theme/* breakpoints.md */.A.md, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(300), (0,polished_esm/* rem */.hO)(300));
var SidebarTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Conferenceelements__SidebarTitle",
  componentId: "sc-mdjsab-5"
})(["font-weight:", ";font-size:", ";padding-bottom:", ";padding-left:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5));
var SidebarLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__SidebarLabel",
  componentId: "sc-mdjsab-6"
})(["padding:", " 0 ", " ", ";margin:", " 0;cursor:pointer;&.active{font-weight:", ";border-left:", " solid ", ";margin-left:", ";}"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(3), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(4), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(4));
var SidebarMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__SidebarMore",
  componentId: "sc-mdjsab-7"
})(["display:block;cursor:pointer;@media (min-width:", "px){display:none;}"], theme/* breakpoints.md */.A.md);
var SidebarContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__SidebarContent",
  componentId: "sc-mdjsab-8"
})(["display:flex;flex-direction:column;padding-top:", ";@media (max-width:", "px){", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, function (prop) {
  return prop.isOpen ? "display: flex" : "display: none";
});
var SidebarItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Conferenceelements__SidebarItem",
  componentId: "sc-mdjsab-9"
})([""]);
var IconDown = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Conferenceelements__IconDown",
  componentId: "sc-mdjsab-10"
})(["svg{margin-right:", ";height:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(16));
;// CONCATENATED MODULE: ./src/components/Conference/Conference.tsx

































var ConferenceTemplate = function ConferenceTemplate(_ref) {
  var _conf$dates, _conf$conference4, _conf$dates2;

  var conf = _ref.conf;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });

  var _useState = (0,react.useState)([]),
      components = _useState[0],
      setComponents = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoggedIn = _useState2[0],
      setIsLoggedIn = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      activeSection = _useState3[0],
      setActiveSection = _useState3[1];

  var _useState4 = (0,react.useState)(),
      colors = _useState4[0],
      setColors = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isOpen = _useState5[0],
      setIsOpen = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isHideMenu = _useState6[0],
      setIsHideMenu = _useState6[1];

  var handleMenuClick = function handleMenuClick(id) {
    var top = document.getElementById(id).offsetTop;
    setIsOpen(false);
    setActiveSection(id);
    return window.scrollTo({
      top: top - 100,
      behavior: 'smooth'
    });
  };

  (0,react.useEffect)(function () {
    if (conf) {
      var _conf$conference;

      setComponents(conf === null || conf === void 0 ? void 0 : (_conf$conference = conf.conference) === null || _conf$conference === void 0 ? void 0 : _conf$conference.components.filter(function (item) {
        return !isLoggedIn && (item === null || item === void 0 ? void 0 : item.type) !== 9 && (item === null || item === void 0 ? void 0 : item.type) !== 10 && (item === null || item === void 0 ? void 0 : item.type) !== 18 || isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj);
      }));
    }
  }, [conf, isLoggedIn]);

  var onScroll = function onScroll() {
    var top = document.getElementById('footer').offsetTop;
    var current = window.pageYOffset;

    if (Number(current) > Number(top)) {
      setIsHideMenu(true);
    } else {
      setIsHideMenu(false);
    }
  };

  (0,react.useEffect)(function () {
    window.addEventListener("scroll", onScroll);
  }, []);
  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);
  (0,react.useEffect)(function () {
    var _conf$conference2, _conf$conference3;

    //kongres sw
    if ((conf === null || conf === void 0 ? void 0 : (_conf$conference2 = conf.conference) === null || _conf$conference2 === void 0 ? void 0 : _conf$conference2.type) === 0) {
      setColors({
        colorTitle: theme/* theme.colors.black */.r.colors.black,
        colorLine: theme/* theme.colors.conferenceEPImain */.r.colors.conferenceEPImain,
        colorLink: theme/* theme.colors.conferenceEPImain */.r.colors.conferenceEPImain,
        colorLight: theme/* theme.colors.conferenceEPIlight */.r.colors.conferenceEPIlight,
        colorLightest: theme/* theme.colors.darkLight */.r.colors.darkLight,
        colorButton: theme/* theme.colors.green */.r.colors.green,
        colorButtonHover: theme/* theme.colors.green */.r.colors.green,
        colorNonLecture: theme/* theme.colors.conferenceGrayDark */.r.colors.conferenceGrayDark,
        colorBlockNumber: theme/* theme.colors.conferenceGrayLight */.r.colors.conferenceGrayLight,
        colorVideoLink: theme/* theme.colors.dark */.r.colors.dark
      });
    } //CS KONGRES


    if ((conf === null || conf === void 0 ? void 0 : (_conf$conference3 = conf.conference) === null || _conf$conference3 === void 0 ? void 0 : _conf$conference3.type) === 1) {
      setColors({
        colorTitle: theme/* theme.colors.conferenceCSmain */.r.colors.conferenceCSmain,
        colorLine: theme/* theme.colors.conferenceCSsuppl */.r.colors.conferenceCSsuppl,
        colorLink: theme/* theme.colors.conferenceCSmain */.r.colors.conferenceCSmain,
        colorLight: theme/* theme.colors.conferenceCSlight */.r.colors.conferenceCSlight,
        colorLightest: theme/* theme.colors.conferenceCSlightest */.r.colors.conferenceCSlightest,
        colorButton: theme/* theme.colors.conferenceCSsuppl */.r.colors.conferenceCSsuppl,
        colorButtonHover: theme/* theme.colors.conferenceCSmain */.r.colors.conferenceCSmain,
        colorNonLecture: theme/* theme.colors.conferenceCSsuppl */.r.colors.conferenceCSsuppl,
        colorBlockNumber: theme/* theme.colors.conferenceCSsuppl */.r.colors.conferenceCSsuppl,
        colorVideoLink: theme/* theme.colors.dark */.r.colors.dark
      });
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content_Content/* default */.Z, {
      withPadding: true,
      children: [(conf === null || conf === void 0 ? void 0 : (_conf$dates = conf.dates) === null || _conf$dates === void 0 ? void 0 : _conf$dates.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Desktop, {
        children: [(components === null || components === void 0 ? void 0 : components.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Sidebar, {
          isHide: isHideMenu,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SidebarMore, {
            onClick: function onClick() {
              return setIsOpen(!isOpen);
            },
            children: [isOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconDown, {
                name: Icon/* Icons.ChevronUp */.PJ.ChevronUp
              }), " Skryt menu", ' ']
            }), !isOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconDown, {
                name: Icon/* Icons.ChevronDown */.PJ.ChevronDown
              }), " Zobrazit menu", ' ']
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SidebarContent, {
            isOpen: isOpen,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SidebarTitle, {
              children: conf === null || conf === void 0 ? void 0 : (_conf$conference4 = conf.conference) === null || _conf$conference4 === void 0 ? void 0 : _conf$conference4.title
            }), components.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(SidebarItem, {
                children: item.inMenu && /*#__PURE__*/(0,jsx_runtime.jsx)(SidebarLabel, {
                  onClick: function onClick() {
                    return handleMenuClick("confSection".concat(item.type));
                  },
                  className: "".concat(activeSection === "confSection".concat(item.type) ? 'active' : ''),
                  children: getTypeTranslationById(item.type)
                })
              }, "MenuSections".concat(item.type));
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Conference_elements_Content, {
          children: components === null || components === void 0 ? void 0 : components.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
              children: [item.type === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceHeader, {
                colors: colors,
                conf: conf,
                setActiveSection: setActiveSection
              }, "mainSection".concat(item.type)), item.type === 10 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceVideo, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 9 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceAttachments, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 11 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceDescription, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceLecturers, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceProgram, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 4 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceTickets, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 5 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceAccomodation, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 6 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePartners, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 8 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReferences, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 12 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrivacy, {
                colors: colors
              }, "mainSection".concat(item.type)), item.type === 7 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePrevious, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 13 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceContact, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 3 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceInvitations, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 14 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceOrderTickets, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 15 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceGuests, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 16 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferencePhotoGallery, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 17 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceReportageVideo, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type)), item.type === 18 && /*#__PURE__*/(0,jsx_runtime.jsx)(ConferenceStream, {
                colors: colors,
                conf: conf
              }, "mainSection".concat(item.type))]
            }, "Sections".concat(item.type).concat(index));
          })
        })]
      }), (conf === null || conf === void 0 ? void 0 : (_conf$dates2 = conf.dates) === null || _conf$dates2 === void 0 ? void 0 : _conf$dates2.length) === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(NoData, {
        children: t('conference.general.noData')
      })]
    })
  });
};

/* harmony default export */ var Conference_Conference = (ConferenceTemplate);

/***/ }),

/***/ 67279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tag; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Tag/Tag.elements.tsx


var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Tagelements__Wrapper",
  componentId: "sc-1w7pdns-0"
})(["", ";", ";padding:", " ", ";margin-right:", ";margin-bottom:", ";border-radius:", ";text-transform:uppercase;font-size:", ";display:inline-block;"], function (prop) {
  return "color: ".concat(prop.color ? prop.color : prop.theme.colors.black);
}, function (prop) {
  return "border: 1px solid ".concat(prop.color ? prop.color : prop.theme.colors.black);
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(4), function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.textSmall;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Tag/Tag.tsx




var TagTemplate = function TagTemplate(_ref) {
  var color = _ref.color,
      name = _ref.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    color: color,
    children: name
  });
};

/* harmony default export */ var Tag = (TagTemplate);

/***/ }),

/***/ 27098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ handleDownloadClick; },
/* harmony export */   "h": function() { return /* binding */ handleDownloadClickAsZip; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55733);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40238);






var zip = new (jszip__WEBPACK_IMPORTED_MODULE_3___default())();
var handleDownloadClick = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(key, name, isCatalogDownload, type) {
    var _link, originalImage, _link2, image, imageBlog, imageURL, link;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isCatalogDownload) {
              _context.next = 7;
              break;
            }

            _link = document.createElement('a');

            _link.setAttribute('target', '_blank');

            _link.href = (0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getCatalogUrl */ .pW)();
            _link.download = name;

            _link.dispatchEvent(new MouseEvent('click'));

            return _context.abrupt("return");

          case 7:
            originalImage = "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getApiURL */ .tU)(), "/media/attachments/").concat(key);

            if (!(type === 'application/pdf')) {
              _context.next = 14;
              break;
            }

            _link2 = document.createElement('a');
            _link2.href = originalImage;
            _link2.download = 'file.pdf';

            _link2.dispatchEvent(new MouseEvent('click'));

            return _context.abrupt("return");

          case 14:
            _context.next = 16;
            return fetch(originalImage);

          case 16:
            image = _context.sent;
            _context.next = 19;
            return image.blob();

          case 19:
            imageBlog = _context.sent;
            imageURL = URL.createObjectURL(imageBlog);
            link = document.createElement('a');
            link.href = imageURL;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleDownloadClick(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var handleDownloadClickAsZip = /*#__PURE__*/function () {
  var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(materials, eventSlug) {
    var formattedFiles, arrOfFiles;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            formattedFiles = materials.map(function (material) {
              return {
                url: "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getApiURL */ .tU)(), "/media/attachments/").concat(material._key),
                name: "".concat(material.name).concat(getFileSuffixByMimeType(material.mime_type))
              };
            });
            arrOfFiles = formattedFiles.map(function (item) {
              return axios__WEBPACK_IMPORTED_MODULE_1___default().get(item.url, {
                responseType: 'blob'
              }).then(function (resp) {
                zip.file(item.name, resp.data);
              });
            });
            return _context2.abrupt("return", Promise.all(arrOfFiles).then(function () {
              zip.generateAsync({
                type: 'blob'
              }).then(function (blob) {
                (0,file_saver__WEBPACK_IMPORTED_MODULE_2__.saveAs)(blob, "".concat(eventSlug, ".zip"));
              });
            })["catch"](function (err) {
              console.log(err);
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleDownloadClickAsZip(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var getFileSuffixByMimeType = function getFileSuffixByMimeType(mimeType) {
  switch (mimeType) {
    case 'application/pdf':
      return '.pdf';

    case 'image/jpeg':
      return '.jpeg';

    case 'image/png ':
      return '.png';

    case 'text/plain':
      return '.txt';

    default:
      return '';
  }
};

/***/ }),

/***/ 25893:
/***/ (function() {

/* (ignored) */

/***/ })

}]);